import {
  Box,
  Button,
  Checkbox,
  Collapse,
  FormControl,
  FormGroup,
  FormLabel,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  styled,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Slider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Field, FieldArray, Form, Formik } from "formik";
import { FormikTextField } from "../../CommonComponents/FormField.js";
import moment from "moment";
import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  ccountry,
  cstate,
  currentTenant,
  prefix1,
  taxtype,
  thousandsdisplay,
  userid,
  financialyearstart,
  financialyearend,
  dataaccess,
  userwhid,
  transactionFrom,
  currency,
} from "../../Common/Credentials.js";
// import { purchaseid } from "../../Common/Permissions.js";
import FileServices from "../../Common/upload/FileServices.js";
import UploadFilesService from "../../Common/upload/UploadFilesService.js";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import { Typography } from "@mui/material";
import InventoryService from "../../inventory/InventoryService.js";
import CategoryServices from "../../Masters/Category/CategoryServices.js";
import WarehouseServices from "../../Masters/Warehouse/WarehouseServices.js";
import PurchaseServices from "../PurchseServices";
import downloadfiles from "../../Common/upload/downloadfiles.js";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Grid } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { NumericFormat } from "react-number-format";
// import TextField from '@mui/material/TextField'
import { FormControlLabel } from "@mui/material";
import IOSSwitch from "../../CommonComponents/IOSSwitch";
import MasterService from "../../Masters/MasterService.js";
import UomServices from "../../Masters/Uom/UomServices.js";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ProductionServices from "../../Production/ProductionServices.js";
import AgentServices from "../../Masters/Agents/AgentServices.js";
import { accounts, production } from "../../Common/Products.js";
import SettingsServices from "../../Settings/SettingsServices.js";
import AdminDashboardServices from "../../DashboardPages/AdminDashboard/AdminDashboardServices.js";
import DepartmentServices from "../../Masters/Department/DepartmentServices.js";
import UpArrow from "../../images/Icons/up-arrow.png";
import { SelectableRadio } from "../../NewUI/NewComponents/SelectableRadio.jsx";
import { OSSwitch } from "../../NewUI/NewComponents/OSSwitch.jsx";
import dayjs from "dayjs";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import { toast } from "../../NewUI/NewComponents/toastService.js";
import TextareaField from "../../NewUI/NewComponents/TextareaField.jsx";
import TaxServices from "../../Masters/Tax/TaxServices.js";
import SelectField from "../../NewUI/NewComponents/SelectField.jsx";
const isInvalid = ["", 0, "0", null, "null", NaN, "NaN", undefined];
let datalist = [];
let updatedatalist = [];
let list = {};
let count = 0;
let serviceList = [];
let doctype = "quotation";
let curmonth, year, day, path;

const useStyles = styled((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    alignItems: "center",
  },
  column: {
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
  },
}));

// const contracttimeList = ["Monthly","Quarterly","Half-Yearly","Yearly"]

class NewPurchase extends Component {
  constructor(props) {
    super(props);
    const pagename = this.props.location.state.pagename;
    const id = this.props.location.state.id;
    const indentid = this.props.location.state.indentid;
    this.state = {
      sloader: false,
      customPOdate: false,
      createdAt: new Date(),
      openCustomPicker: false,
      taxtypelist: ["GST", "VAT"],
      gsttypelist: ["INTRASTATE", "INTERSTATE"],
      potype: "0",
      pagename: pagename,
      id: id,
      indentid: indentid,
      agentsdata: [],
      agentreq: false,
      agent: "",
      agentid: "",
      iid: "",
      data: [],
      taxesList: [],
      supplier: "",
      supplierid: "",
      supcountry: "",
      itemid: "",
      itemname: "",
      itemlist: [],
      filteritemlist: [],
      quantity: 0,
      cost: 0,
      hsn: "",
      tax: 0,
      cgst: 0,
      sgst: 0,
      addparams: "False",
      taxamount: 0,
      totaltaxamount: 0,
      cctotaltaxamount: 0,
      totalprice: 0,
      itemprice: 0,
      totalamount: 0,
      cctotalamount: 0,
      grandtotal: 0,
      ccgrandtotal: 0,
      listData: [],
      status: 0,
      suppliers: [],
      parameters: 0,
      uomlist: [],
      uom: "",
      uomid: "",
      WarehouseList: [],
      warehouse: "",
      whid: "",
      DepartmentList: [],
      department: "",
      deptid: "",
      CategoryList: [],
      category: "",
      catid: "",
      advance: 0,
      ccadvance: 0,
      advancestatus: false,
      paymentterms: 0,
      serviceitemList: [],
      filterserv: [],
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: 0,
      servicecost: 0,
      servicecgst: 0,
      servicesgst: 0,
      serviceigst: 0,
      servicegst: 0,
      servicevat: 0,
      servicetaxamount: 0,
      servicecostwttax: 0,
      servicedescription: "",
      contracttype: "",
      contracttypeList: [],
      serviceList: [],
      ServiceCategoryList: [],
      servicetotal: "",
      grandservicetotal: 0,
      ccgrandservicetotal: 0,
      quotationpath: "",
      quotationfile: "",
      serviceerr: "",
      selectedFiles: undefined,
      progress: 0,
      message: "",
      isError: false,
      fileInfos: [],
      fileInfo: "",
      partyid: "",
      error: false, //<---- here
      errorMessage: {}, //<-----here
      loader: false,
      path: "",
      file: "",
      milestone: [],
      recurringtype: [],
      contracttime: "",
      contractstartdate: new Date(),
      contractenddate: new Date(),
      milestonesavebtn: false,
      percentagemessage: "",
      size: "",
      colour: "",
      thickness: "",
      brand: "",
      model: "",
      totalmtrroll: "",
      poitemstatus: "2",
      poitemtype: "1",
      sizelist: [],
      colourlist: [],
      thicknesslist: [],
      brandslist: [],
      closingStock: 0,
      pro: true,
      serv: false,
      prosev: false,

      currencylist: [],
      currencyid: "",
      currency: "",
      curconversionrate: 1,
      convertionreq: false,
      basecurrency: currency,

      porecurring: false,
      porecurringtype: "",
      porecurringfrom: new Date(),
      porecurringtill: new Date(),
      taxrequired: true,
      taxtype: taxtype,
      gsttype: "INTRASTATE",
      open: false,

      importpo: false,
      tcsreq: "",
      tcs: 0,
      tcsableamount: 0,
      tcsamount: 0,

      IndentIdList: [],
      indentitems: [],
      indentitemid: "",
      itemsfor: [
        { id: "0", name: "Internal Use" },
        { id: "1", name: "Reselling" },
        { id: "2", name: "Raw Material" },
      ],
      Internalusefor: [
        { id: "1", name: "Asset" },
        { id: "2", name: "Consumption" },
      ],
      assettypes: [
        { id: "0", name: "Own" },
        { id: "1", name: "Thirdparty" },
      ],
      assettype: "0",
      orderfrom: 0,
      reqquotationupload: false,

      settings: "",
      inventorydata: [],
      blockedpurchasequantity: 0,
      blockedsalesquantity: 0,
      openingbalance: 0,
      creditamount: 0,
      adjustopen: false,
      adjustcredit: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.selectFile = this.selectFile.bind(this);
    this.upload = this.upload.bind(this);
  }

  handlePurchaseTypeChange = (pro, serv, prosev) => {
    this.setState({
      pro: pro,
      serv: serv,
      prosev: prosev,
      potype: prosev ? "2" : serv ? "1" : "0",
      itemid: "",
      itemname: "",
      quantity: "",
      cost: "",
      hsn: "",
      tax: "",
      cgst: "",
      sgst: "",
      addparams: "False",
      taxamount: "",
      totaltaxamount: 0,
      cctotaltaxamount: 0,
      totalprice: "",
      itemprice: "",
      grandtotal: 0,
      totalamount: 0,
      cctotalamount: 0,
      ccgrandtotal: 0,
      uom: "",
      uomid: "",
      category: "",
      catid: "",
      advance: 0,
      advancestatus: false,
      paymentterms: 0,
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: "",
      servicecost: "",
      servicetaxamount: "",
      servicecostwttax: "",
      servicedescription: "",
      contracttype: "",
      servicetotal: "",
      grandservicetotal: 0,
      quotationpath: "",
      quotationfile: "",
      serviceerr: "",
      selectedFiles: undefined,
      progress: 0,
      message: "",
      isError: false,
      fileInfos: [],
      fileInfo: "",
      partyid: "",
      size: "",
      colour: "",
      thickness: "",
      brand: "",
      totalmtrroll: "",
      listData: [],
    });
    datalist = [];
  };

  handleProductChange = () => {
    this.setState({
      pro: true,
      serv: false,
      prosev: false,
      potype: "0",
      supplier: "",
      supplierid: "",
      itemid: "",
      itemname: "",
      quantity: "",
      cost: "",
      hsn: "",
      tax: "",
      cgst: "",
      sgst: "",
      addparams: "False",
      taxamount: "",
      totaltaxamount: 0,
      cctotaltaxamount: 0,
      totalprice: "",
      itemprice: "",
      grandtotal: 0,
      ccgrandtotal: 0,
      totalamount: 0,
      cctotalamount: 0,
      uom: "",
      uomid: "",
      category: "",
      catid: "",
      advance: 0,
      advancestatus: false,
      paymentterms: 0,
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: "",
      servicecost: "",
      servicetaxamount: "",
      servicecostwttax: "",
      servicedescription: "",
      contracttype: "",
      servicetotal: "",
      grandservicetotal: 0,
      quotationpath: "",
      quotationfile: "",
      serviceerr: "",
      selectedFiles: undefined,
      progress: 0,
      message: "",
      isError: false,
      fileInfos: [],
      fileInfo: "",
      partyid: "",
      size: "",
      colour: "",
      thickness: "",
      brand: "",
      totalmtrroll: "",
      listData: [],
    });
    datalist = [];
  };
  handleServiceChange = () => {
    this.setState({
      serv: true,
      pro: false,
      prosev: false,
      potype: "1",
      supplier: "",
      supplierid: "",
      itemid: "",
      itemname: "",
      quantity: "",
      cost: "",
      hsn: "",
      tax: "",
      cgst: "",
      sgst: "",
      addparams: "False",
      taxamount: "",
      totaltaxamount: 0,
      cctotaltaxamount: 0,
      totalprice: "",
      itemprice: "",
      grandtotal: 0,
      ccgrandtotal: 0,
      totalamount: 0,
      cctotalamount: 0,
      uom: "",
      uomid: "",
      category: "",
      catid: "",
      advance: 0,
      advancestatus: false,
      paymentterms: 0,
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: "",
      servicecost: "",
      servicetaxamount: "",
      servicecostwttax: "",
      servicedescription: "",
      contracttype: "",
      servicetotal: "",
      grandservicetotal: 0,
      quotationpath: "",
      quotationfile: "",
      serviceerr: "",
      selectedFiles: undefined,
      progress: 0,
      message: "",
      isError: false,
      fileInfos: [],
      fileInfo: "",
      partyid: "",
      size: "",
      colour: "",
      thickness: "",
      brand: "",
      totalmtrroll: "",
      listData: [],
    });
    datalist = [];
  };
  handleProSerChange = () => {
    this.setState({
      prosev: true,
      pro: false,
      serv: false,
      potype: "2",
      supplier: "",
      supplierid: "",
      itemid: "",
      itemname: "",
      quantity: "",
      cost: "",
      hsn: "",
      tax: "",
      cgst: "",
      sgst: "",
      addparams: "False",
      taxamount: "",
      totaltaxamount: 0,
      cctotaltaxamount: 0,
      totalprice: "",
      itemprice: "",
      grandtotal: 0,
      ccgrandtotal: 0,
      totalamount: 0,
      cctotalamount: 0,
      uom: "",
      uomid: "",
      category: "",
      catid: "",
      advance: 0,
      advancestatus: false,
      paymentterms: 0,
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: "",
      servicecost: "",
      servicetaxamount: "",
      servicecostwttax: "",
      servicedescription: "",
      contracttype: "",
      servicetotal: "",
      grandservicetotal: 0,
      quotationpath: "",
      quotationfile: "",
      serviceerr: "",
      selectedFiles: undefined,
      progress: 0,
      message: "",
      isError: false,
      fileInfos: [],
      fileInfo: "",
      partyid: "",
      size: "",
      colour: "",
      thickness: "",
      brand: "",
      totalmtrroll: "",
      listData: [],
    });
    datalist = [];
  };

  handleStartDateChange = (date) => {
    this.setState({ contractstartdate: date });
  };
  handleEndDateChange = (date) => {
    this.setState({ contractenddate: date });
  };
  handleQuatation = () => {
    downloadfiles.download(this.state.path, this.state.file);
  };

  handleAgent = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        agent: values.name,
        agentid: values.id,
      });
    } else {
      this.setState({ agent: "", agentid: "" });
    }
  };

  selectFile = (event) => {
    this.setState({
      selectedFiles: event.target.files,
    });
  };

  handlePOtype = (e) => {
    this.setState({
      potype: e.target.value,
      listData: [],
      serviceList: [],
      grandservicetotal: 0,
      ccgrandservicetotal: 0,
      grandtotal: 0,
      ccgrandtotal: 0,
      totalamount: 0,
      cctotalamount: 0,
    });
    datalist = [];
    serviceList = [];
  };

  onSubmit = () => {
    count = count + 1;
    const {
      totalpricewtax,
      taxamount,
      totalprice,
      basetotalpricewtax,
      basetaxamount,
      basetotalprice,
    } = this.CalculateTotalPrice();
    list = {
      // id: this.state.id,
      indentitemid: this.state.indentitemid,
      itemid: this.state.itemid,
      name: this.state.itemname,
      hsn: this.state.hsn,
      deptid: this.state.deptid,
      department: this.state.department,
      price: parseFloat(this.state.cost) * this.state.curconversionrate,
      ccprice: parseFloat(this.state.cost),
      quantity: parseFloat(this.state.quantity),
      uom: this.state.uom,
      uomid: parseFloat(this.state.uomid),
      catid: this.state.catid,
      category: this.state.category,
      tax: parseFloat(this.state.tax),
      taxamount: parseFloat(basetaxamount),
      cctaxamount: parseFloat(taxamount),
      itemprice:
        parseFloat(this.state.itemprice) * this.state.curconversionrate,
      ccitemprice: parseFloat(basetotalprice),
      totalprice: parseFloat(basetotalprice),
      cctotalprice: parseFloat(totalprice),
      totalpricewtax: parseFloat(basetotalpricewtax),
      cctotalpricewtax: parseFloat(totalpricewtax),
      poitemstatus: this.state.poitemstatus,
      poitemtype: this.state.poitemstatus === "0" ? this.state.poitemtype : "0",
      assettype:
        this.state.poitemstatus === "0" && this.state.poitemtype === "1"
          ? this.state.assettype
          : "2",
      parameters: this.state.parameters,
      brand: this.state.brand,
      size: this.state.size,
      colour: this.state.colour,
      thickness: this.state.thickness,
      totalmtrroll: this.state.totalmtrroll,
    };

    datalist.push(list);
    updatedatalist.push(list);
    this.setState({ listData: datalist });
    if (this.state.indentitems.length !== 0) {
      this.state.indentitems.find(
        (e) => e.id === this.state.indentitemid
      ).quantity =
        this.state.indentitems.find((e) => e.id === this.state.indentitemid)
          .quantity - this.state.quantity;
    }
    this.setState({
      grandtotal: this.state.grandtotal + basetotalpricewtax,
      totalamount: basetotalprice,
      cctotalamount: totalprice,
      tcsableamount: this.state.grandtotal + basetotalpricewtax,
      totaltaxamount: this.state.totaltaxamount + basetaxamount,
      ccgrandtotal: this.state.ccgrandtotal + totalpricewtax,
      cctotaltaxamount: this.state.cctotaltaxamount + taxamount,
      quantity: "",
      cost: 0,
      totalprice: 0,
      indentitems: this.state.indentitems,
    });
    toast("Product Added", "success")
  };

  validatepercentage = (values) => {
    let totalper = 0;
    values.map((e) => (totalper = e.percentage + totalper));
  };

  handlemilestonevalues = (values) => {
    let totalpercentage = 0;
    values.map((e) => {
      return (totalpercentage = e.percentage + totalpercentage);
    });
    if (totalpercentage > 100) {
      this.setState({ percentagemessage: "Percentage is Greaterthan 100%" });
    } else if (totalpercentage < 100) {
      this.setState({ percentagemessage: "Percentage is Lessthan 100%" });
    } else {
      this.setState({
        milestone: values,
        milestonesavebtn: true,
        percentagemessage: "Milestones Saved Scussesfully",
      });
    }
  };

  handlecreatedAtDateChange = (date) => {
    this.setState({ createdAt: date });
    this.setState({
      fed: moment(date).format("yyyy-MM-DD HH:mm:ss"),
    });
  };
  handlecustomPODate = () => {
    this.setState({
      customPOdate: this.state.customPOdate === true ? false : true,
      createdAt: new Date(),
    });
  };

  handleadvancestatus = (e) => {
    this.setState({ advancestatus: !this.state.advancestatus, advance: 0 });
  };

  handleAdvanceChange = (value) => {
    if (
      this.state.adjustopen &&
      this.state.adjustcredit
    ) {
      if (
        this.state.openingbalance +
        this.state.creditamount >
        this.state.grandtotal -
        this.state.totaltaxamount
      ) {
        this.setState({
          advance:
            value >
              this.state.totaltaxamount
              ? this.state
                .totaltaxamount
              : value,
        });
      } else {
        this.setState({
          advance:
            value >
              this.state.grandtotal -
              (this.state
                .openingbalance +
                this.state.creditamount)
              ? this.state.grandtotal -
              (this.state
                .openingbalance +
                this.state
                  .creditamount)
              : value,
        }, () => this.setState({ ccadvance: (1 / this.state.curconversionrate) * this.state.advance }));
      }
    } else if (this.state.adjustopen) {
      if (
        this.state.openingbalance >
        this.state.grandtotal -
        this.state.totaltaxamount
      ) {
        this.setState({
          advance:
            value >
              this.state.totaltaxamount
              ? this.state
                .totaltaxamount
              : value,
        }, () => this.setState({ ccadvance: (1 / this.state.curconversionrate) * this.state.advance }));
      } else {
        this.setState({
          advance:
            value >
              this.state.grandtotal -
              this.state.openingbalance
              ? this.state.grandtotal -
              this.state
                .openingbalance
              : value,
        }, () => this.setState({ ccadvance: (1 / this.state.curconversionrate) * this.state.advance }));
      }
    } else if (
      this.state.adjustcredit
    ) {
      if (
        this.state.creditamount >
        this.state.grandtotal -
        this.state.totaltaxamount
      ) {
        this.setState({
          advance:
            value >
              this.state.totaltaxamount
              ? this.state
                .totaltaxamount
              : value,
        }, () => this.setState({ ccadvance: (1 / this.state.curconversionrate) * this.state.advance }));
      } else {
        this.setState({
          advance:
            value >
              this.state.grandtotal -
              this.state.creditamount
              ? this.state.grandtotal -
              this.state.creditamount
              : value,
        }, () => this.setState({ ccadvance: (1 / this.state.curconversionrate) * this.state.advance }));
      }
    } else {
      this.setState({
        advance:
          value >
            this.state.grandtotal
            ? this.state.grandtotal
            : value,
      }, () => this.setState({ ccadvance: (1 / this.state.curconversionrate) * this.state.advance }));
    }
  }

  handleSliderChange = (event, newValue) => {
    this.setState({ paymentterms: newValue });
  };

  handlepaymentterms = (event) => {
    this.setState({ paymentterms: Number(event.target.value) });
  };

  handleBlur = () => {
    if (this.state.paymentterms < 0) {
      this.setState({ paymentterms: 0 });
    } else if (this.state.paymentterms > 120) {
      this.setState({ paymentterms: 120 });
    }
  };

  handleWarehouse = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        whid: values.id,
        warehouse: values.name,
        department: "",
        deptid: "",
        DepartmentList: [],
        itemname: "",
        hsnid: "",
        hsn: "",
        quantity: "",
        cost: "",
        uom: "",
        uomid: "",
        description: "",
      });
      DepartmentServices.deptbywarehouse(values.id).then((response) => {
        this.setState({
          DepartmentList: response.data,
        });
        if (response.data.length === 1) {
          this.setState({
            department: response.data[0].name,
            deptid: response.data[0].id,
          });
        }
      });
    } else {
      this.setState({
        whid: "",
        warehouse: "",
        department: "",
        deptid: "",
        DepartmentList: [],
        itemname: "",
        hsnid: "",
        hsn: "",
        quantity: "",
        cost: "",
        uom: "",
        uomid: "",
        description: "",
      });
    }
  };

  handleDepartment = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        department: values.name,
        deptid: values.id,
      });
    } else {
      this.setState({ department: "", deptid: "" });
    }
  };

  handleCategory = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        catid: values.id,
        category: values.category,
        filteritemlist: this.state.itemlist.filter(
          (e) => e.catid === values.id
        ),
        itemid: "",
        itemname: "",
        hsn: "",
        tax: "",
        cgst: "",
        sgst: "",
        cost: "",
        quantity: "",
        addparams: "False",
      });
    } else {
      this.setState({
        itemid: "",
        itemname: "",
        hsn: "",
        tax: "",
        cgst: "",
        sgst: "",
        cost: "",
        quantity: "",
        category: "",
        catid: "",
        addparams: "False",
        filteritemlist: [],
      });
    }
  };

  handlesupplier = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      let lv = "Personal";

      if (values.ledgerid === null || values.ledgerid === undefined) {
        if (accounts === "YES") {
          //   if (
          //     window.confirm(
          //       `Ledger account is not created for supplier ${values.companyname}, so no payment or receipt can be done. Press 'ok' to create ledger or 'cancel' to continue`
          //     )
          //   ) {
          //     this.props.navigate("/newparty", {
          //       id: -1,
          //       name: "New Party Ledger",
          //       lv,
          //     });
          //   }
          // } else {
          alert(
            `Ledger account is not created for supplier ${values.companyname}, so no payment or receipt can be done`
          );
        }
      }
      this.setState({
        supplierid: values.id,
        supplier: values.companyname,
        partyid: values.id,
        // taxtype: values.taxtype,
        gsttype:
          values.statename === cstate && values.countryname === ccountry
            ? "INTRASTATE"
            : "INTERSTATE",
        supcountry: values.countryname,
        creditamount: values.creditamount,
        openingbalance: values.openingbalance,
        convertionreq:
          values.currency === this.state.basecurrency ? false : true,
        // currency: values.currency,
        // currencyid: this.state.currencylist.find(
        //   (e) => e.currency === values.currency
        // ).id,
        quantity: "",
        cost: "",
        // addparams: "False",
        totalprice: "",
        grandtotal: 0,
        ccgrandtotal: 0,
        totalamount: 0,
        cctotalamount: 0,
      });
      //     if(values.ledgerid === null){
      //       if(window.confirm(`Please Create a Ledger Account of ${values.companyname}`)){
      //         this.props.navigate("/newparty", {
      //           id: -1,
      //           name: "New Party Ledger",
      //           lv,
      //         })
      //       }else{
      //         this.setState({
      //           supplierid:'',
      //           supplier: '',
      //           partyid: '',
      //           quantity: "" ,
      //           cost: "",
      //           totalprice: "",
      //           addparams:"False",
      //           grandtotal: 0
      //         });
      //         }
      //        }
    } else {
      this.setState({
        supplierid: "",
        supplier: "",
        partyid: "",
        gsttype: "INTRASTATE",
        supcountry: "",
        convertionreq: false,
        currency: "",
        currencyid: "",
        quantity: "",
        cost: "",
        addparams: "False",
        totalprice: "",
        grandtotal: 0,
        ccgrandtotal: 0,
        totalamount: 0,
        cctotalamount: 0,
      });
    }
  };

  CalculateTotalPrice = () => {
    let halftaxamountroundoff = (
      (((this.state.tax / 2) * this.state.cost) / 100) *
      parseFloat(this.state.quantity)
    ).toFixed(2);
    let taxamountroundoff =
      this.state.taxtype === "GST" &&
        ccountry === "India" &&
        this.state.gsttype === "INTRASTATE"
        ? parseFloat(halftaxamountroundoff) + parseFloat(halftaxamountroundoff)
        : ((this.state.tax * this.state.cost) / 100) *
        parseFloat(this.state.quantity);
    return {
      totalpricewtax:
        this.state.cost * this.state.quantity + parseFloat(taxamountroundoff),
      taxamount: taxamountroundoff,
      totalprice: this.state.cost * this.state.quantity,
      basetotalpricewtax:
        (this.state.cost * this.state.quantity +
          parseFloat(taxamountroundoff)) *
        this.state.curconversionrate,
      basetaxamount: taxamountroundoff * this.state.curconversionrate,
      basetotalprice:
        this.state.cost * this.state.quantity * this.state.curconversionrate,
    };
  };
  CalculateServicePrices = (e) => {
    const cost = (parseFloat(this.state.servicecost === "" ? 0 : this.state.servicecost) * parseFloat(this.state.quantity === "" ? 0 : this.state.quantity))
    const halftaxamount = ((this.state.servicetax === "" ? 0 : this.state.servicetax / 2) / 100) * cost
    const taxamount = ((this.state.servicetax === "" ? 0 : this.state.servicetax) / 100) * cost
    console.log(cost, halftaxamount, taxamount, this.state.servicecost, this.state.quantity)
    return {
      servicetaxamount: taxamount,
      servicecgst: halftaxamount,
      servicesgst: halftaxamount,
      serviceigst: taxamount,
      servicegst: taxamount,
      servicevat: taxamount,
      servicecostwttax: cost + taxamount,
      baseservicetaxamount: taxamount * this.state.curconversionrate,
      baseservicecostwttax: (cost + taxamount) * this.state.curconversionrate,
    };
  };


  // onSubmit = (e) => {

  //   let halftaxamountroundoff = ((((this.state.tax / 2) * this.state.cost) / 100) * parseFloat(this.state.quantity)).toFixed(2)
  //   let taxamountroundoff = this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? parseFloat(halftaxamountroundoff) + parseFloat(halftaxamountroundoff) : (((this.state.tax) * this.state.cost) / 100) * parseFloat(this.state.quantity)
  //   this.setState({
  //     totalprice:
  //       (this.state.cost * this.state.quantity) +
  //       parseFloat(taxamountroundoff),
  //     taxamount: taxamountroundoff,
  //     itemprice: this.state.cost * this.state.quantity,
  //   });
  // };

  handleQuantityChange = (e) => {
    this.setState({ quantity: e.target.value });
    this.setState({ totalprice: "" });
  };

  handleUOM = (value, values) => {
    if (value !== "") {
      this.setState({ uomid: values.uom.id, uom: value });
    }
  };

  handleSize = (value, values) => {
    if (value !== "") {
      this.setState({ size: value });
    }
  };

  handleColour = (value, values) => {
    if (value !== "") {
      this.setState({ colour: value });
    }
  };

  handlepoitemstatus = (e, value) => {
    this.setState({ poitemstatus: value ? value.id : null });
  };
  handleChange = (e, value) => {
    this.setState({ poitemtype: value ? value.id : null });
  };

  handleAssetTypeChange = (e, value) => {
    this.setState({ assettype: value ? value.id : null });
  };

  handleSelect(value, values) {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        itemid: values.id,
        itemname: values.name,
        totalprice: "",
      });

      let itemdata = this.state.itemlist.filter(
        (data) => data.id === values.id
      );
      itemdata.map((data) =>
        this.setState({
          hsn: data.hsn,
          tax: this.state.taxrequired === false ? 0 : data.tax,
          cgst: this.state.taxrequired === false ? 0 : data.tax / 2,
          sgst: this.state.taxrequired === false ? 0 : data.tax / 2,
          parameters: data.parameters,
          description: data.description,
          uom: data.uomname,
          uomid: data.id,
          brand: data.brand,
          model: data.model,
          addparams: data.addparams,
        })
      );
    } else {
      this.setState({
        itemid: "",
        itemname: "",
        totalprice: "",
        hsn: "",
        tax: "",
        cgst: "",
        sgst: "",
        parameters: "",
        description: "",
        uom: "",
        brand: "",
        model: "",
        addparams: "False",
      });
    }
  }

  removeItemFromList(id) {
    let deleteditem = datalist.find((person, index) => index === id);
    const newlist = datalist.filter((person, index) => index !== id);
    if (this.state.indentitems.length !== 0) {
      this.state.indentitems.find(
        (e) => e.id === deleteditem.indentitemid
      ).quantity =
        this.state.indentitems.find((e) => e.id === deleteditem.indentitemid)
          .quantity + deleteditem.quantity;
    }
    this.setState({
      listData: newlist,
      grandtotal: this.state.grandtotal - deleteditem.totalpricewtax,
      ccgrandtotal: this.state.ccgrandtotal - deleteditem.cctotalpricewtax,
      totalamount: this.state.totalamount - deleteditem.totalprice,
      cctotalamount: this.state.cctotalamount - deleteditem.cctotalprice,
      tcsableamount: this.state.tcsableamount - deleteditem.totalpricewtax,
      cctcsableamount: this.state.tcsableamount - deleteditem.cctotalpricewtax,
      totaltaxamount: this.state.totaltaxamount - deleteditem.taxamount,
      cctotaltaxamount: this.state.totaltaxamount - deleteditem.cctaxamount,
      indentitems: this.state.indentitems,
      advance: this.state.advancestatus
        ? this.state.advance <=
          this.state.grandtotal - deleteditem.totalpricewtax
          ? this.state.advance
          : this.state.grandtotal - deleteditem.totalpricewtax
        : 0,
    });
    datalist = newlist;
  }

  removeServiceFromList(id) {
    let deleteservice = serviceList.find((person, index) => index === id);
    let tp = deleteservice.servicetotal;
    const newlist = serviceList.filter((person, index) => index !== id);
    this.setState({
      serviceList: newlist,
      grandservicetotal: this.state.grandservicetotal - tp,
    });
    serviceList = newlist;
    toast(`Service "${deleteservice.service}" removed`, "error")
  }

  handleSubmit = (values) => {
    let filedata = this.state.fileInfos.map((e) => e.name).toLocaleString();
    path =
      prefix1 +
      "/" +
      doctype +
      "/" +
      this.state.partyid +
      "/" +
      year +
      "/" +
      curmonth +
      "/" +
      day;
    if (
      this.state.reqquotationupload === true &&
      filedata === "" &&
      this.state.file === ""
    ) {
      this.setState({ message: "Please Upload Quotation" });
    } else {
      this.setState({ sloader: true });
      if (this.state.potype === "1") {
        // serviceList = [
        //   {
        //     service: this.state.service,
        //     serviceid: this.state.serviceid,
        //     servicecatid: this.state.servicecatid,
        //     servicecode: this.state.servicecode,
        //     servicecategory: this.state.servicecategory,
        //     servicecost: parseFloat(this.state.servicecost),
        //     servicetax: this.state.servicetax,
        //     servicedescription: this.state.servicedescription,
        //     servicetotal:
        //       parseFloat(this.state.servicecost) +
        //       parseFloat(this.state.servicecost) *
        //         (this.state.servicetax / 100),
        //     recurringtype: this.state.contracttime,
        //     milestonelist: this.state.milestone,
        //     contracttype: this.state.contracttype,
        //     contractstartdate: this.state.contractstartdate,
        //     contractenddate: this.state.contractenddate,
        //     // contractfile:filedata,
        //     // contractpath:path,
        //   },
        // ];
      }
      let podata = {
        agent: this.state.agentid,
        orderfrom: this.state.orderfrom,
        indentid: this.state.indentid,
        poid: this.state.id.toLocaleString(),
        potype: parseInt(this.state.potype),
        importpo: this.state.importpo,
        supplier: this.state.supplier,
        supplierid: this.state.supplierid,
        invoiceuploadrequired:
          this.state.settings.invuploadm === "YES" ? true : false,
        grandtotal: parseFloat(this.state.grandtotal),
        ccgrandtotal: parseFloat(this.state.ccgrandtotal),
        totalamount: this.state.totalamount,
        cctotalamount: this.state.cctotalamount,
        whid: this.state.whid,
        deptid: this.state.deptid,
        advanceamountreq: parseFloat(this.state.advance),
        advancepaymentreq: this.state.advancestatus === false ? 0 : 1,
        createdby: userid,
        updatedby: userid,
        tenantid: currentTenant,
        status: this.state.status,
        totaltaxamount: parseFloat(this.state.totaltaxamount),
        cctotaltaxamount: parseFloat(this.state.cctotaltaxamount),
        paymentterms: this.state.paymentterms,
        podata: datalist,
        servicel:
          this.state.potype === "1" ? serviceList : this.state.serviceList,
        grandservicetotal: parseFloat(this.state.grandservicetotal),
        ccgrandservicetotal: parseFloat(this.state.ccgrandservicetotal),
        quotationpath: this.state.path === "" ? path : this.state.path,
        quotationfile: this.state.file === "" ? filedata : this.state.file,

        taxtype: this.state.taxtype,
        taxrequired: this.state.taxrequired,
        gsttype: this.state.gsttype === "INTRASTATE" ? 0 : 1,
        porecurring: this.state.porecurring === true ? "Blanketpo" : "Onetime",
        recurringtype: this.state.porecurringtype,
        postartdate: this.state.porecurringfrom,
        poenddate: this.state.porecurringtill,
        tcsreq: this.state.tcsreq === false ? 0 : 1,
        tcs: this.state.tcsreq === false ? 0 : this.state.tcs,
        tcsamount:
          this.state.tcsreq === false ? 0 : parseFloat(this.state.tcsamount),
        tcsableamount:
          this.state.tcsreq === false
            ? 0
            : parseFloat(this.state.tcsableamount),
        directpo: false,
        currency: this.state.currency,
        curconversionrate: parseFloat(this.state.curconversionrate),
        createdAt: this.state.createdAt,
        customPOdate: this.state.customPOdate,
        adjustcredit: this.state.adjustcredit,
        adjustopen: this.state.adjustopen,
        adjustcredit: this.state.adjustcredit,
      };
      if (this.state.pagename === "Edit Purchase Order") {
        PurchaseServices.NewOrder(podata)
          .then(() => this.props.navigate(-1))
          .catch((e) => {
            this.setState({ sloader: false });
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
          });
      } else {
        PurchaseServices.NewOrder(podata)
          .then((response) =>
            this.props.navigate(
              { pathname: "/viewpurchaseorder" },
              { state: { id: response.data } }
            )
          )
          .catch((e) => {
            this.setState({ sloader: false });
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
          });
      }
    }
  };

  handleService = (value, values) => {
    // alert(this.state.taxrequired)
    this.setState({
      serviceid: values.id,
      service: values.service,
      servicetax:
        this.state.taxrequired === false ? 0 : values.servicetax,
      servicecode: values.servicecode,
      servicecost: "",
      servicecostwttax: "",
      servicetaxamount: "",
      milestonelist: [],
      percentagemessage: "",
      milestonesavebtn: false,
    });
  };

  handleServicecategory = (value, values) => {
    if (values) {
      this.setState({
        servicecatid: values.id,
        servicecategory: values.category,
        filterserv: this.state.serviceitemList.filter(
          (e) => e.catid === values.id
        ),
        servicecost: 0,
        servicecostwttax: 0,
        servicetaxamount: 0,
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    } else {
      this.setState({
        servicecatid: null,
        servicecategory: null,
        filterserv: [],
        servicecost: 0,
        servicecostwttax: 0,
        servicetaxamount: 0,
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    }
  };

  handleServiceAmountChange = (e) => {
    this.setState({
      servicecost: e.target.value,
      servicetaxamount: (this.state.servicetax / 100) * parseFloat(e.target.value),
      servicecgst: ((this.state.servicetax / 100) * parseFloat(e.target.value)) / 2,
      servicesgst: ((this.state.servicetax / 100) * parseFloat(e.target.value)) / 2,
      serviceigst: (this.state.servicetax / 100) * parseFloat(e.target.value),
      servicegst: (this.state.servicetax / 100) * parseFloat(e.target.value),
      servicevat: (this.state.servicetax / 100) * parseFloat(e.target.value),
      servicecostwttax: parseFloat(e.target.value) + (this.state.servicetax / 100) * parseFloat(e.target.value),
    });
  };

  handleaddService = () => {
    if (
      this.state.supplier === "" ||
      this.state.service === "" ||
      this.state.servicedescription === "" ||
      this.state.servicecost === "" ||
      this.state.servicecategory === ""
    ) {
      this.setState({ serviceerr: "Please fill all the Fields" });
      toast("Please fill all the Mandatory Fields", "error")
    } else {
      const basetotal = parseFloat(this.state.servicecost) * parseFloat(this.state.quantity) * this.state.curconversionrate
      const basetaxamount = (basetotal * (this.state.servicetax / 100)) * this.state.curconversionrate
      const total = parseFloat(this.state.servicecost) * parseFloat(this.state.quantity)
      const taxamount = (total * (this.state.servicetax / 100))
      let services = {
        contracttype: this.state.contracttype,
        service: this.state.service,
        serviceid: this.state.serviceid,
        servicecatid: this.state.servicecatid,
        servicecode: this.state.servicecode,
        servicecategory: this.state.servicecategory,
        servicecost: parseFloat(this.state.servicecost) * this.state.curconversionrate,
        ccservicecost: parseFloat(this.state.servicecost),
        // servicetax: this.state.servicetax,
        servicetaxamount: basetaxamount,
        ccservicetaxamount: taxamount,
        quantity: this.state.quantity,
        servicedescription: this.state.servicedescription,
        servicetotal: basetotal,
        ccservicetotal: total,
        servicetotalwtax: basetotal + basetaxamount,
        ccservicetotalwtax: total + taxamount,
      };
      serviceList.push(services);
      this.setState({
        serviceList: serviceList,
        grandservicetotal: this.state.grandservicetotal + basetotal + basetaxamount,
        ccgrandservicetotal: this.state.ccgrandservicetotal + total + taxamount,
        servicecost: 0,
        servicedescription: "",
        serviceerr: "",
      });
      toast("Service Added", "success")
    }
  };

  handleTaxtypeChange = (value, values) => {
    this.setState({ taxtype: values });
  };
  handleGsttypeChange = (value, values) => {
    this.setState({ gsttype: values });
  };

  handleCurrency = (value, values) => {
    if (value !== "") {
      this.setState({
        currencyid: values.id,
        currency: values.currency,
      });
    }
  };

  handleCurconversionrate = (e) => {
    this.setState({
      curconversionrate: e.target.value,
    });
  };

  handlemulticurrencyrequired = () => {
    this.setState({ convertionreq: !this.state.convertionreq });
  };

  handletaxrequired = () => {
    this.setState({ taxrequired: !this.state.taxrequired });
  };
  handleTaxTypeChange = (e) => {
    this.setState({ taxtype: e.target.value });
  };

  handleimportpurchase = () => {
    this.setState({ importpo: !this.state.importpo });
  };

  handleRecurringTill = (date) => {
    this.setState({ porecurringtill: date });
  };

  handleRecurringFrom = (date) => {
    this.setState({ porecurringfrom: date });
  };

  handletcsreq = (e) => {
    this.setState({ tcsreq: !this.state.tcsreq });
  };

  handletcsChange = (e) => {
    this.setState({
      tcs: parseFloat(e.target.value),
      tcsamount: ((this.state.tcsableamount * e.target.value) / 100).toFixed(3),
    });
  };

  refreshData() {
    const { id } = this.props.location.state;
    datalist = [];
    list = {};
    updatedatalist = [];
    count = 0;
    serviceList = [];

    SettingsServices.GetSettings(currentTenant).then((response) => {
      this.setState({ settings: response.data });
    });

    MasterService.getParameters(currentTenant).then((res) => {
      this.setState({
        parameters: res.data,
        sizelist: res.data.size,
        colourlist: res.data.colour,
        thicknesslist: res.data.thickness,
        brandslist: res.data.brands,
      });
    });

    TaxServices.getTaxes(currentTenant).then(response => this.setState({ taxesList: response.data.sort((a, b) => a.tax - b.tax) }))

    PurchaseServices.GetContrctType()
      .then((response) => {
        this.setState({ contracttypeList: response.data });
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
    PurchaseServices.GetRecurringduration().then((response) => {
      this.setState({ recurringtype: response.data });
    });
    UomServices.getUOM(currentTenant).then((response) =>
      this.setState({
        uomlist: response.data,
      })
    );
    WarehouseServices.getWarehouses(currentTenant).then((response) =>
      this.setState(
        {
          WarehouseList: response.data,
        },
        () => {
          if (this.state.WarehouseList.length === 1) {
            this.setState({
              warehouse: this.state.WarehouseList[0].name,
              whid: this.state.WarehouseList[0].id,
            });
            DepartmentServices.deptbywarehouse(
              this.state.WarehouseList[0].id
            ).then((response) => {
              this.setState({
                DepartmentList: response.data,
              });
              if (response.data.length === 1) {
                this.setState({
                  department: response.data[0].name,
                  deptid: response.data[0].id,
                });
              }
            });
          } else if (dataaccess === "Organization" || dataaccess === "User") {
            this.setState({
              warehouse: this.state.WarehouseList.find((e) => e.id === userwhid)
                .name,
              whid: this.state.WarehouseList.find((e) => e.id === userwhid).id,
              WarehouseList: this.state.WarehouseList.filter(
                (e) => e.id === userwhid
              ),
            });
            DepartmentServices.deptbywarehouse(
              this.state.WarehouseList[0].id
            ).then((response) => {
              this.setState({
                DepartmentList: response.data,
              });
              if (response.data.length === 1) {
                this.setState({
                  department: response.data[0].name,
                  deptid: response.data[0].id,
                });
              }
            });
          }
        }
      )
    );

    PurchaseServices.GetItemlist(currentTenant).then((resp) =>
      this.setState({
        itemlist: resp.data,
        closingStock:
          resp.data === undefined || resp.data.length === 0
            ? 0
            : resp.data.length === 0
              ? 0
              : resp.data[0].closingstock,
      })
    );

    InventoryService.getServices(currentTenant).then((res) => {
      this.setState({ serviceitemList: res.data });
    });

    let datadao = {
      tenantid: currentTenant,
      startdate: financialyearstart,
      enddate: financialyearend,
      userid: userid,
      dataaccess: dataaccess,
    };

    PurchaseServices.GetAllPurchases(datadao).then((response) =>
      this.setState({
        data: response.data,
      })
    );

    CategoryServices.getCategory(currentTenant).then((response) =>
      this.setState({
        CategoryList: response.data.filter((e) => e.categorytype === "Product"),
        ServiceCategoryList: response.data.filter(
          (e) => e.categorytype === "Service"
        ),
      })
    );

    PurchaseServices.GetAllSellers(currentTenant).then((res) =>
      this.setState({
        suppliers: res.data,
      })
    );

    MasterService.GetAllCurrency().then((response) => {
      this.setState({ currencylist: response.data });
    });

    MasterService.GetCurrencyOfTenant(currentTenant).then((response) => {
      this.setState({
        basecurrency: response.data.currency,
        currencyid: response.data.id,
        currency: response.data.currency,
        curconversionrate: 1,
      });
    });

    AgentServices.getAgents(currentTenant).then((res) => {
      this.setState({ agentsdata: res.data });
    });

    ProductionServices.getIndentingIdListForPo(currentTenant).then(
      (response) => {
        this.setState({ IndentIdList: response.data });
      }
    );

    InventoryService.retriveStock(currentTenant).then((res) => {
      this.setState({ inventorydata: res.data });
    });
    AdminDashboardServices.blockedpurchasequantity(currentTenant).then((res) =>
      this.setState({ blockedpurchasequantity: res.data })
    );
    AdminDashboardServices.blockedsalesquantity(currentTenant).then((res) =>
      this.setState({ blockedsalesquantity: res.data })
    );

    if (id < 1) {
      return;
    }

    PurchaseServices.GetPurchases(id).then((response) =>
      this.setState(
        {
          potype: response.data.potype.toLocaleString(),
          supplier: response.data.supplier,
          agent: response.data.agent,
          agentid: response.data.agentid,
          agentreq:
            response.data.agentid === undefined ||
              response.data.agentid === null
              ? false
              : true,
          supplierid: response.data.supplierid,
          listData: response.data.purchaseitem,
          serviceList: response.data.servicelist,
          totaltaxamount: response.data.totaltaxamount,
          grandtotal: response.data.grandproducttotal,
          grandservicetotal: response.data.grandservicetotal,
          whid: response.data.whid,
          warehouse: response.data.warehouse,
          advance: response.data.advanceamountreq,
          advancestatus:
            response.data.advancepaymentreq === "True" ? true : false,
          paymentterms: response.data.paymentterms,
          path: response.data.quotationpath,
          file: response.data.quotationfile,
          tcsreq: response.data.tcsreq,
          tcs: response.data.tcs,
          tcsamount: response.data.tcsamount,
          tcsableamount: response.data.tcsableamount,
        },
        () => (datalist = response.data.purchaseitem)
      )
    );
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }

    year = new Date().getFullYear();
    day = new Date().getDate();
    let mn = new Date().getMonth() + 1;
    curmonth = moment(mn, "M").format("MMMM");

    this.refreshData();
  }

  upload() {
    let currentFile = this.state.selectedFiles[0];

    this.setState({ progress: 100, currentFile: currentFile });

    UploadFilesService.upload(
      currentFile,
      year,
      curmonth,
      doctype,
      this.state.partyid,
      day,
      (event) => {
        this.setState({
          progress: Math.round((100 * event.loaded) / event.total),
        });
      }
    )
      .then((response) => {
        this.setState({
          message: response.data.message,
          isError: false,
        });
        return FileServices.getFiles1(currentFile.name);
      })
      .then((files) => {
        this.setState({ fileInfos: files.data });
      })

      .catch(() => {
        this.setState({
          progress: 0,
          message: "Could not upload the file!",
          currentFile: undefined,
          isError: true,
        });
      });

    this.setState({ selectedFiles: undefined });
  }

  handleporecurringtypeChange = (e) => {
    this.setState({ porecurringtype: e.target.value });
  };

  handleporecurring = (e) => {
    this.setState({ porecurring: !this.state.porecurring });
  };

  handlePOFrom = (value) => {
    this.setState({
      orderfrom: value,
      poitemstatus: "3",
      potype: "0",
      pro: true,
      serv: false,
      prosev: false,
    });
  };

  handleIndent = (value) => {
    if (value !== "") {
      this.setState({ indentid: value });
      ProductionServices.getIndentingItems(value).then((response) =>
        this.setState({
          indentitems: response.data.indentingitems,
          whid: response.data.whid,
          warehouse: response.data.warehouse,
          wcid: response.data.wcid,
          workcenter: response.data.workcenter,
        })
      );
    }
  };

  handleIndentItem = (values) => {
    let itemdata = this.state.itemlist.filter(
      (data) => data.id === values.itemid
    );
    itemdata.map((data) =>
      this.setState({
        indentitemid: values.id,
        itemid: values.itemid,
        itemname: values.itemname,
        hsn: data.hsn,
        tax: this.state.taxrequired === false ? 0 : data.tax,
        cgst: this.state.taxrequired === false ? 0 : data.tax / 2,
        sgst: this.state.taxrequired === false ? 0 : data.tax / 2,
        parameters: data.parameters,
        description: data.description,
        catid: data.categoryid,
        quantity: values.quantity,
        category: this.state.CategoryList.find((e) => e.id === data.categoryid)
          .category,
        uom: values.uom,
        uomid: this.state.uomlist.find((e) => e.name === values.uom).id,
      })
    );
    this.setState({ totalprice: "" });
  };

  validate(type) {
    let errors = {};

    if (this.state.agentreq === true) {
      if (this.state.agentid === "" || this.state.agentid === undefined) {
        errors.agent = "Please Select Agent";
      }
    }

    if (this.state.potype === "1" || (this.state.potype === "2" && type === "service")) {
      if (this.state.supplierid === "") {
        errors.supplier = "Please Select Supplier";
      }

      if (this.state.warehouse === "") {
        errors.warehouse = "Please Enter Org Unit";
      }

      if (this.state.service === "") {
        errors.service = "Please Select Service";
      }


      if (this.state.servicecategory === "") {
        errors.servicecategory = "Please Select Service Category";
      }

      if (this.state.servicecost === "") {
        errors.servicecost = "Please Enter Amount";
      }

      // if(this.state.servicedescription ===''){
      //   errors.servicedescription = "Please Enter Description";
      // }

      if (this.state.potype === "1" && this.state.contracttype === "") {
        errors.contracttype = "Please Select Contract type";
      }

      if (isInvalid.includes(this.state.servicedescription)) {
        errors.servicedescription = "Please enter service description (min 5 characters)"
      }

    } else {
      if (this.state.supplierid === "") {
        errors.supplier = "Please Select Supplier";
      }

      if (this.state.category === "") {
        errors.category = "Category is required";
      }

      if (this.state.itemname === "") {
        errors.itemname = "Please Select Item";
      }
      if (this.state.quantity === "") {
        errors.quantity = "Please Enter Quantity";
      }
      if (this.state.cost === "") {
        errors.cost = "Please Enter Unit Price";
      }


      if (this.state.quantity < 0) {
        errors.quantity = "Value Should be greaterthan or equal to 0";
      }

    }
    return errors;
  }

  onfocus() {
    document
      .getElementById("amount")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document.getElementById("amount").addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  }
  onsamountfocus() {
    document
      .getElementById("samount")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("samount")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }
  onquantityfocus() {
    document
      .getElementById("quantity")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("quantity")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }
  oncostfocus() {
    document
      .getElementById("cost")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document.getElementById("cost").addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  }
  onadvancefocus() {
    document
      .getElementById("advance")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("advance")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }
  oncurrencyconvtfocus() {
    document
      .getElementById("standard-adornment-amount")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("standard-adornment-amount")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }

  render() {
    let {
      agent,
      agentid,
      agentreq,
      agentsdata,
      supcountry,
      potype,
      id,
      itemid,
      itemname,
      cost,
      quantity,
      totalprice,
      itemprice,
      tax,
      cgst,
      sgst,
      supplier,
      supplierid,
      uomlist,
      uom,
      uomid,
      hsn,
      addparams,
      itemlist,
      filteritemlist,
      suppliers,
      WarehouseList,
      warehouse,
      whid,
      DepartmentList,
      department,
      deptid,
      CategoryList,
      category,
      catid,
      advance,
      advancestatus,
      paymentterms,
      sizelist,
      colourlist,
      thicknesslist,
      brandslist,
      saleorderdata,
      preitemList,
      parameters,
      size,
      brand,
      model,
      colour,
      totalmtrroll,
      thickness,
      filterserv,
      serviceitemList,
      service,
      serviceid,
      ServiceCategoryList,
      servicecategory,
      servicecatid,
      servicetax,
      servicecgst,
      servicesgst,
      serviceigst,
      servicegst,
      servicevat,
      servicecode,
      servicecost,
      servicecostwttax,
      servicetaxamount,
      serviceList,
      contracttype,
      contracttypeList,
      servicetotal,
      grandservicetotal,
      quotationpath,
      quotationfile,
      servicedescription,
      selectedFiles,
      progress,
      isError,
      message,
      recurringtype,
      contracttime,
      poitemstatus,
      poitemtype,
      currencylist,
      convertionreq,
      currencyid,
      currency,
      curconversionrate,
      basecurrency,
      tcs,
      tcsamount,
      tcsreq,
      importpo,
      reqquotationupload,
    } = this.state;
    let displaysavebutton;
    let displayrequest;

    if (this.state.potype === "2") {
      if (this.state.grandtotal === 0 || this.state.grandservicetotal === 0) {
        displaysavebutton = (
          <button className="btn btn-sm hovbuttonColour" disabled>
            {/* <i className="fa fa-save mr-1" /> {"Save"} */}
          </button>
        );
      } else {
        displaysavebutton = (
          <button
            className="btn btn-sm hovbuttonColour"
            type="button"
            onClick={this.handleSubmit}
            disabled={this.state.sloader}
          >
            {this.state.sloader === true ? (
              <>
                <Spinner animation="border" size="sm" className="mr-1" />
                {"Saving..."}{" "}
              </>
            ) : (
              <>
                <i className="fa fa-save mr-1" /> {"Save"}
              </>
            )}
          </button>
        );
      }
    } else {
      if (this.state.grandtotal === 0) {
        displaysavebutton = (
          <button className="btn btn-sm hovbuttonColour" disabled>
            <i className="fa fa-save mr-1" /> {"Save"}
          </button>
        );
      } else {
        displaysavebutton = (
          <button
            className="btn btn-sm hovbuttonColour"
            type="button"
            onClick={this.handleSubmit}
            disabled={this.state.sloader}
          >
            {this.state.sloader === true ? (
              <>
                <Spinner animation="border" size="sm" className="mr-1" />
                {"Saving..."}{" "}
              </>
            ) : "Save"}
          </button>
        );
      }
    }

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="card card-info tw-relative">
            <ol className="breadcrumb float-sm-right">
              {/* <span
                as="button"
                className="text-secondary mr-2 cursorPointer"
                onClick={() => this.props.navigate(-1)}
              >
                ❮ Back
              </span> */}
              <li className="breadcrumb-item text-secondary">
                <Link to="/purchase">Home</Link>
              </li>
              <li className="breadcrumb-item text-secondary">
                <Link to="/purchaseorder">Purchase Order</Link>
              </li>
              <li className="breadcrumb-item active">{this.state.pagename}</li>
            </ol>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={this.state.sloader}
            // onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <div className="card-body m-0 pt-0">
              <Formik
                initialValues={{
                  agent,
                  agentid,
                  agentreq,
                  agentsdata,
                  supcountry,
                  potype,
                  id,
                  itemid,
                  itemname,
                  cost,
                  hsn,
                  quantity,
                  tax,
                  cgst,
                  sgst,
                  totalprice,
                  itemprice,
                  supplierid,
                  supplier,
                  uomlist,
                  uom,
                  uomid,
                  addparams,
                  itemlist,
                  filteritemlist,
                  suppliers,
                  WarehouseList,
                  warehouse,
                  whid,
                  DepartmentList,
                  department,
                  deptid,
                  CategoryList,
                  category,
                  catid,
                  advance,
                  advancestatus,
                  paymentterms,
                  sizelist,
                  colourlist,
                  thicknesslist,
                  brandslist,
                  saleorderdata,
                  preitemList,
                  parameters,
                  size,
                  brand,
                  model,
                  colour,
                  totalmtrroll,
                  thickness,
                  filterserv,
                  serviceitemList,
                  service,
                  serviceid,
                  ServiceCategoryList,
                  servicecategory,
                  servicecatid,
                  servicetax,
                  servicecgst,
                  servicesgst,
                  serviceigst,
                  servicegst,
                  servicevat,
                  servicecost,
                  servicecostwttax,
                  servicetaxamount,
                  servicetotal,
                  servicecode,
                  serviceList,
                  contracttype,
                  contracttypeList,
                  servicedescription,
                  grandservicetotal,
                  selectedFiles,
                  quotationfile,
                  quotationpath,
                  progress,
                  recurringtype,
                  contracttime,
                  milestone: [
                    {
                      name: "",
                      expecteddate: "",
                      percentage: 0,
                      amount: 0,
                      amountwttax: 0,
                    },
                  ],
                  poitemstatus,
                  poitemtype,
                  currencylist,
                  convertionreq,
                  currencyid,
                  currency,
                  curconversionrate,
                  basecurrency,
                  tcs,
                  tcsamount,
                  tcsreq,
                  importpo,
                  reqquotationupload,
                }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}
              >
                {({ setFieldValue, values, errors, validateForm }) => (
                  <Form autoComplete="off">
                    {this.state.pagename === "Edit Purchase Order" ? (
                      ""
                    ) : (
                      <fieldset className=" col-md-12 p-0 m-0">
                        <div className="form-row p-0 m-0">
                          {this.state.pagename === "Edit Purchase Order" ||
                            production === "NO" ? (
                            ""
                          ) : (
                            <>
                              <div className="d-flex gap-2">
                                <fieldset
                                  className={`tab-button mr-2 ${this.state.orderfrom === 0
                                    ? "active-tab"
                                    : "inactive-tab"
                                    }`}
                                  onClick={() => this.handlePOFrom(0)}
                                  disabled={this.state.orderfrom === 0}
                                >
                                  New Purchase Order
                                  <img
                                    src={UpArrow}
                                    alt="Up Arrow"
                                    style={{
                                      marginLeft: "4px",
                                      width: "1.5rem",
                                      height: "1.5rem",
                                      padding: "4px",
                                      transform: "rotate(30deg)",
                                    }}
                                  />
                                </fieldset>

                                <fieldset
                                  className={`tab-button mr-2 ${this.state.orderfrom === 1
                                    ? "active-tab"
                                    : "inactive-tab"
                                    }`}
                                  onClick={() => this.handlePOFrom(1)}
                                  disabled={this.state.orderfrom === 1}
                                >
                                  Store Indent Order
                                  <img
                                    src={UpArrow}
                                    alt="Up Arrow"
                                    style={{
                                      marginLeft: "4px",
                                      width: "1.5rem",
                                      height: "1.5rem",
                                      padding: "4px",
                                      transform: "rotate(30deg)",
                                    }}
                                  />
                                </fieldset>
                              </div>

                              <fieldset className=" col-md-12 p-0 m-0" />
                              {this.state.orderfrom === 1 ? (
                                <>
                                  <fieldset className=" col-md-4 mb-4">
                                    <Autocomplete
                                      id="subaccount"
                                      className="subacc-select"
                                      name="indentid"
                                      options={this.state.IndentIdList}
                                      getOptionLabel={(option) => `${option}`}
                                      value={
                                        values.indentid ? undefined : undefined
                                      }
                                      onChange={(e, value) => {
                                        setFieldValue("indentid", value);
                                      }}
                                      disabled={datalist.length !== 0}
                                      renderInput={(params) => (
                                        <FormikTextField
                                          {...params}
                                          className="form-control"
                                          type="text"
                                          name="indentid"
                                          onBlur={(e) => {
                                            this.handleIndent(e.target.value);
                                          }}
                                          label={`Select Indent No. (${this.state.indentid})`}
                                          variant="standard"
                                          fullWidth
                                        />
                                      )}
                                    />
                                  </fieldset>
                                  <fieldset className=" col-md-12 p-0 m-0" />
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}

                          {this.state.orderfrom === 1 ||
                            (this.state.settings.purchaseservice === "NO" &&
                              this.state.settings.purchasepands === "NO") ? (
                            ""
                          ) : (
                            <>
                              <fieldset className=" col-md-12 pt-3 m-0">
                                {/* <ul className="skewstyledbuttons d-flex flex-wrap" style={{ gap: '1.5rem' }}>

                                  <li className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                                    <span className="mb-2 mr-2" style={{ fontSize: '13px' }}>Products</span>
                                    <FormControlLabel
                                      control={
                                        <IOSSwitch
                                          className="sm"
                                          checked={this.state.pro}
                                          onChange={this.handleProductChange}
                                          name="checkedB"
                                        />
                                      }
                                    />
                                  </li>

                                  {this.state.settings.purchaseservice === "YES" && (
                                    <li className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                                      <span className="mb-2 mr-2" style={{ fontSize: '13px' }}>Services</span>
                                      <FormControlLabel
                                        control={
                                          <IOSSwitch
                                            className="sm"
                                            checked={this.state.serv}
                                            onChange={this.handleServiceChange}
                                            name="checkedB"
                                          />
                                        }
                                      />
                                    </li>
                                  )}

                                  {this.state.settings.purchasepands === "YES" && (
                                    <li className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                                      <span className="mb-2 mr-2" style={{ fontSize: '13px' }}>Products & Services</span>
                                      <FormControlLabel
                                        control={
                                          <IOSSwitch
                                            className="sm"
                                            checked={this.state.prosev}
                                            onChange={this.handleProSerChange}
                                            name="checkedB"
                                          />
                                        }
                                      />
                                    </li>
                                  )}
                                </ul> */}

                                <div className="UI-form-section">
                                  {/* <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                                                                        Add invoice information
                                                                    </h3> */}
                                  <div
                                    className="UI-form-grid"
                                    style={{
                                      gridTemplateColumns:
                                        "repeat(auto-fit, minmax(200px, 1fr))",
                                      gap: "16px",
                                    }}
                                  >
                                    <div
                                      onClick={() =>
                                        this.handlePurchaseTypeChange(
                                          true,
                                          false,
                                          false
                                        )
                                      }
                                      style={{
                                        backgroundColor: this.state.pro
                                          ? "#e4f0f7"
                                          : "#f8fafc",
                                        padding: "16px",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        position: "relative",
                                        border: this.state.pro
                                          ? "1px solid #3574de"
                                          : "1px solid #e2e8f0",
                                        transition: "all 0.2s ease",
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "16px",
                                          right: "16px",
                                        }}
                                      >
                                        <SelectableRadio
                                          checked={this.state.pro}
                                          size="lg"
                                        />
                                      </div>
                                      <div
                                        style={{
                                          display: "inline-block",
                                          fontWeight: 600,
                                          fontSize: "0.9rem",
                                          color: this.state.pro
                                            ? "#3574de"
                                            : "#4d4d4d",
                                        }}
                                      >
                                        Only Products
                                      </div>
                                    </div>
                                    {this.state.settings.salesservice ===
                                      "YES" && (
                                        <div
                                          onClick={() =>
                                            this.handlePurchaseTypeChange(
                                              false,
                                              true,
                                              false
                                            )
                                          }
                                          style={{
                                            backgroundColor: this.state.serv
                                              ? "#e4f0f7"
                                              : "#f8fafc",
                                            padding: "16px",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            position: "relative",
                                            border: this.state.serv
                                              ? "1px solid #3574de"
                                              : "1px solid #e2e8f0",
                                            transition: "all 0.2s ease",
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "16px",
                                              right: "16px",
                                            }}
                                          >
                                            <SelectableRadio
                                              checked={this.state.serv}
                                              size="lg"
                                            />
                                          </div>
                                          <div
                                            style={{
                                              display: "inline-block",
                                              fontWeight: 600,
                                              fontSize: "0.9rem",
                                              color: this.state.serv
                                                ? "#3574de"
                                                : "#4d4d4d",
                                            }}
                                          >
                                            Only Services
                                          </div>
                                        </div>
                                      )}
                                    {this.state.settings.purchasepands ===
                                      "YES" && (
                                        <div
                                          onClick={() =>
                                            this.handlePurchaseTypeChange(
                                              false,
                                              false,
                                              true
                                            )
                                          }
                                          style={{
                                            backgroundColor: this.state.prosev
                                              ? "#e4f0f7"
                                              : "#f8fafc",
                                            padding: "16px",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            position: "relative",
                                            border: this.state.prosev
                                              ? "1px solid #3574de"
                                              : "1px solid #e2e8f0",
                                            transition: "all 0.2s ease",
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "16px",
                                              right: "16px",
                                            }}
                                          >
                                            <SelectableRadio
                                              checked={this.state.prosev}
                                              size="lg"
                                            />
                                          </div>
                                          <div
                                            style={{
                                              display: "inline-block",
                                              fontWeight: 600,
                                              fontSize: "0.9rem",
                                              color: this.state.prosev
                                                ? "#3574de"
                                                : "#4d4d4d",
                                            }}
                                          >
                                            Products & Services
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </fieldset>
                            </>
                          )}
                        </div>
                      </fieldset>
                    )}
                    <div className="row tw-border tw-border-dotted tw-mb-5">
                      <fieldset className=" col-md-12 m-0 p-0">
                        <h3
                          className="UI-section-title"
                          style={{
                            backgroundColor: "#f4f4f4",
                            padding: "12px",
                          }}
                        >
                          Customer and Order Information
                        </h3>
                      </fieldset>

                      <fieldset className=" col-md-3 mb-2">
                        <AutoCompeteField id="supplier" name="supplier" type="text" options={suppliers} valueKey={"companyname"} labelKey={"companyname"} value={this.state.supplier} label={`Select Supplier`} required placeholder="" onChange={this.handlesupplier} disabled={this.state.grandtotal > 0} error={errors?.["supplier"]} />
                      </fieldset>
                      {agentsdata && agentsdata.length > 0 && (
                        <fieldset className=" col-md-3">
                          <AutoCompeteField id="agent" name="agent" type="text" options={agentsdata} valueKey={"name"} labelKey={"name"} value={this.state.agent} label={`Select Agent`} placeholder="" onChange={this.handleAgent} disabled={this.state.grandtotal > 0} />
                        </fieldset>
                      )}
                      <fieldset className=" col-md-3">
                        <AutoCompeteField id="warehouse" name="warehouse" type="text" options={WarehouseList} valueKey={"name"} labelKey={"name"} value={this.state.warehouse} label={`Select Org Unit`} placeholder="" onChange={this.handleWarehouse} disabled={this.state.grandtotal > 0 || this.state.orderfrom !== 0} required error={errors?.["warehouse"]} />
                      </fieldset>
                      <div className=" col-md-12 m-0 p-0" />
                      {/* Toggles Group - Explicit 25px gap as requested */}
                      <div
                        style={{
                          display: "flex",
                          gap: "25px",
                          alignItems: "flex-end",
                          flexShrink: 0,
                        }}
                      >
                        {/* Toggles - The first 3 components */}
                        {this.state.supplier && (
                          <>
                            {" "}
                            <div
                              className="UI-"
                              style={{ minWidth: "fit-content", flexShrink: 1 }}
                            >
                              <FormControlLabel
                                labelPlacement="start"
                                className="os-switch-label"
                                style={{ gap: "4px" }}
                                control={
                                  <OSSwitch
                                    checked={this.state.taxrequired}
                                    onChange={(checked) =>
                                      this.setState({ taxrequired: checked })
                                    }
                                    disabled={
                                      (this.state.accepteditems &&
                                        this.state.accepteditems.length > 0) ||
                                      (this.state.serviceList &&
                                        this.state.serviceList.length > 0)
                                    }
                                  />
                                }
                                label="With Tax"
                              />
                            </div>
                            <div
                              className="UI-"
                              style={{ minWidth: "fit-content", flexShrink: 1 }}
                            >
                              <FormControlLabel
                                labelPlacement="start"
                                style={{ gap: "4px" }}
                                className="os-switch-label"
                                control={
                                  <OSSwitch
                                    checked={this.state.importpo}
                                    onChange={() =>
                                      this.setState({
                                        importpo: !this.state.importpo,
                                      })
                                    }
                                  />
                                }
                                label="Import Purchase"
                              />
                            </div>
                          </>
                        )}

                        <div
                          className="UI-"
                          style={{
                            minWidth: "fit-content",
                            flexShrink: 1,
                            marginRight: "5px",
                          }}
                        >
                          <FormControlLabel
                            labelPlacement="start"
                            style={{ gap: "4px" }}
                            className="os-switch-label"
                            control={
                              <OSSwitch
                                checked={this.state.customPOdate}
                                onChange={() =>
                                  this.setState({
                                    customPOdate: !this.state.customPOdate,
                                  })
                                }
                              />
                            }
                            label="Custom Date"
                          />
                        </div>
                      </div>
                      {/* Conditional Fields - Will use the parent 12px gap */}
                      {/* Conditional Fields */}
                      {this.state.supplier &&
                        this.state.taxrequired === true && (
                          <>
                            <AutoCompeteField style={{ minWidth: "120px", marginLeft: "12px", flexShrink: 1 }} id="taxtype" name="taxtype" type="text" options={this.state.taxtypelist} valueKey={null} labelKey={null} value={this.state.taxtype} label={`Tax Type`} placeholder="" onChange={this.handleTaxtypeChange} disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)} />
                            {/* <div
                              className="UI-"
                              style={{
                                minWidth: "120px",
                                marginLeft: "12px",
                                flexShrink: 1,
                              }}
                            >
                              <label className="UI-label">Tax Type</label>
                              <Autocomplete
                                id="currency"
                                name="currency"
                                options={this.state.taxtypelist}
                                getOptionLabel={(option) => option}
                                value={this.state.taxtype}
                                onChange={this.handleTaxtypeChange}
                                disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes( this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                                renderInput={(params) => (
                                  <div
                                    ref={params.InputProps.ref}
                                    style={{
                                      position: "relative",
                                      width: "200px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      {...params.inputProps}
                                      className="UI-input"
                                      placeholder="Select Taxtype"
                                      value={this.state.taxtype}
                                      style={{
                                        width: "100%",
                                        // paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                      }}
                                    />
                                  </div>
                                )}
                              />
                            </div> */}
                            {ccountry === "India" &&
                              this.state.taxtype === "GST" && (<>
                                <AutoCompeteField style={{ minWidth: "120px", marginLeft: "12px", flexShrink: 1 }} id="gsttype" name="gsttype" type="text" options={this.state.gsttypelist} valueKey={null} labelKey={null} value={this.state.gsttype} label={`GST Type`} placeholder="" onChange={this.handleGsttypeChange} disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)} />
                                {/* <div
                                  className="UI-"
                                  style={{
                                    minWidth: "120px",
                                    marginLeft: "12px",
                                    flexShrink: 1,
                                  }}
                                >
                                  <label className="UI-label">GST Type</label>
                                  <Autocomplete
                                    id="currency"
                                    name="currency"
                                    options={this.state.gsttypelist}
                                    getOptionLabel={(option) => option}
                                    value={this.state.gsttype}
                                    onChange={this.handleGsttypeChange}
                                    disabled={
                                      !isInvalid.includes(
                                        this.state.grandtotal
                                      ) ||
                                      !isInvalid.includes(
                                        this.state.grandservicetotal
                                      ) ||
                                      this.state.orderfrom === 1 ||
                                      !isInvalid.includes(
                                        this.state.saleorderid
                                      )
                                    }
                                    renderInput={(params) => (
                                      <div
                                        ref={params.InputProps.ref}
                                        style={{
                                          position: "relative",
                                          width: "200px",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          {...params.inputProps}
                                          className="UI-input"
                                          placeholder="Select Taxtype"
                                          value={this.state.gsttype}
                                          style={{
                                            width: "100%",
                                            // paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                          }}
                                        />
                                      </div>
                                    )}
                                  />
                                </div> */}
                              </>
                              )}
                          </>
                        )}

                      {this.state.customPOdate && (
                        <div
                          className="UI-"
                          style={{
                            minWidth: "280px",
                            flexShrink: 1,
                            marginLeft: "12px",
                          }}
                        >
                          <label className="UI-label">
                            Custom Purchase Date
                          </label>
                          <div style={{ display: "flex", gap: "8px" }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                disableFuture
                                showTodayButton
                                open={this.state.openCustomPicker}
                                onOpen={() =>
                                  this.setState({ openCustomPicker: true })
                                }
                                onClose={() =>
                                  this.setState({ openCustomPicker: false })
                                }
                                minDate={(() => {
                                  let minDate;
                                  if (
                                    typeof transactionFrom !== "undefined" &&
                                    transactionFrom
                                  ) {
                                    minDate = dayjs(transactionFrom);
                                  } else {
                                    minDate = dayjs("1900-01-01");
                                  }
                                  return minDate;
                                })()}
                                maxDate={dayjs()}
                                value={
                                  this.state.createdAt
                                    ? dayjs(this.state.createdAt)
                                    : null
                                }
                                onChange={(date) => {
                                  const currentCustom = dayjs(
                                    this.state.createdAt || new Date()
                                  );
                                  const nextCustomDate = dayjs(date)
                                    .hour(currentCustom.hour())
                                    .minute(currentCustom.minute())
                                    .second(currentCustom.second());

                                  const nextCustomMoment = moment(
                                    nextCustomDate.toDate()
                                  );
                                  const currentDue = this.state.duedate
                                    ? moment(this.state.duedate)
                                    : moment(new Date());

                                  const nextDue = nextCustomMoment
                                    .clone()
                                    .add(this.state.creditperiod, "days")
                                    .hour(currentDue.hour())
                                    .minute(currentDue.minute())
                                    .second(currentDue.second());

                                  this.setState({
                                    createdAt: nextCustomDate.toDate(),
                                    duedate: nextDue,
                                  });
                                }}
                                renderInput={(params) => (
                                  <div
                                    style={{
                                      position: "relative",
                                      flex: 1,
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      this.setState({ openCustomPicker: true })
                                    }
                                  >
                                    <input
                                      {...params.inputProps}
                                      ref={params.inputRef}
                                      className="UI-input"
                                      placeholder="Date"
                                      style={{
                                        width: "100%",
                                        paddingRight: "40px",
                                        cursor: "pointer",
                                      }}
                                      readOnly
                                    />
                                    <div
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {params.InputProps.endAdornment}
                                    </div>
                                  </div>
                                )}
                              />
                            </LocalizationProvider>
                            <input
                              type="time"
                              className="UI-input"
                              style={{ width: "110px", flexShrink: 1 }}
                              value={
                                this.state.customcreatedAt
                                  ? dayjs(this.state.customcreatedAt).format(
                                    "HH:mm"
                                  )
                                  : "00:00"
                              }
                              onChange={(e) => {
                                const [hours, minutes] =
                                  e.target.value.split(":");
                                const newDate = dayjs(
                                  this.state.customcreatedAt || new Date()
                                )
                                  .hour(parseInt(hours))
                                  .minute(parseInt(minutes));
                                this.setState({
                                  customcreatedAt: newDate.toDate(),
                                  duedate: moment(newDate.toDate()).add(
                                    this.state.creditperiod,
                                    "days"
                                  ),
                                });
                              }}
                            />
                          </div>
                        </div>
                      )}

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "auto auto auto",
                          alignItems: "center",
                          gap: "12px",
                          marginLeft: "12px",
                        }}
                      >
                        {/* First column: Invoice Currency */}
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label className="UI-label">Order Currency</label>
                          <Autocomplete
                            id="currency"
                            name="currency"
                            options={currencylist}
                            getOptionLabel={(option) => option.currency}
                            value={
                              this.state.currency
                                ? currencylist.find(
                                  (e) => e.currency === this.state.currency
                                )
                                : null
                            }
                            onChange={this.handleCurrency}
                            disabled={
                              !isInvalid.includes(this.state.grandtotal) ||
                              !isInvalid.includes(
                                this.state.grandservicetotal
                              ) ||
                              this.state.orderfrom === 1 ||
                              !isInvalid.includes(this.state.saleorderid)
                            }
                            renderInput={(params) => (
                              <div
                                ref={params.InputProps.ref}
                                style={{ position: "relative", width: "200px" }}
                              >
                                <input
                                  type="text"
                                  {...params.inputProps}
                                  className="UI-input"
                                  placeholder="Select currency"
                                  value={this.state.currency}
                                  style={{
                                    width: "100%",
                                    paddingRight:
                                      this.state.currency &&
                                        this.state.currency !==
                                        this.state.basecurrency
                                        ? "30px"
                                        : undefined,
                                  }}
                                />
                                {this.state.currency &&
                                  this.state.currency !==
                                  this.state.basecurrency && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        pointerEvents: "none",
                                        fontSize: "13px",
                                        color: "#666",
                                      }}
                                    >
                                      1
                                    </span>
                                  )}
                              </div>
                            )}
                          />
                        </div>

                        {/* Equals sign column - only shown when currencies differ */}
                        {this.state.currency !== this.state.basecurrency && (
                          <div
                            style={{
                              alignSelf: "center",
                              marginTop:
                                "20px" /* offset to ignore the label space */,
                            }}
                          >
                            <span
                              style={{
                                fontSize: "16px",
                                fontWeight: 500,
                                lineHeight: 1,
                              }}
                            >
                              =
                            </span>
                          </div>
                        )}

                        {/* Third column: Conversion Rate (only shown when currencies differ) */}
                        {this.state.currency !== this.state.basecurrency && (
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <label className="UI-label">Conversion Rate</label>
                            <div
                              style={{ position: "relative", width: "260px" }}
                            >
                              <input
                                type="number"
                                className="UI-input"
                                value={this.state.curconversionrate}
                                onChange={(e) =>
                                  this.setState(
                                    { curconversionrate: e.target.value },
                                    this.recomputeTotals
                                  )
                                }
                                disabled={
                                  !isInvalid.includes(this.state.grandtotal) ||
                                  !isInvalid.includes(
                                    this.state.grandservicetotal
                                  ) ||
                                  this.state.orderfrom === 1 ||
                                  !isInvalid.includes(this.state.saleorderid)
                                }
                                style={{
                                  width: "100%",
                                  paddingRight: "55px",
                                }}
                              />
                              <span
                                style={{
                                  position: "absolute",
                                  right: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  pointerEvents: "none",
                                  fontSize: "13px",
                                  color: "#666",
                                }}
                              >
                                {this.state.basecurrency}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className=" col-md-12 my-2">
                        <div className="form-row">
                          <fieldset className=" col-md-4 mt-2 m-0">
                            <FormGroup row>
                              <FormControlLabel
                                labelPlacement="start"
                                style={{ gap: "4px" }}
                                className="os-switch-label"
                                control={
                                  <OSSwitch
                                    checked={this.state.porecurring}
                                    onChange={this.handleporecurring}
                                  />
                                }
                                label="Purchase Order Recurring Required"
                              />
                            </FormGroup>
                          </fieldset>
                          {this.state.porecurring === true ? (
                            <>
                              <fieldset className=" col-md-2 m-0 p-0">
                                <FormControl
                                  variant="standard"
                                  className="w-100"
                                >
                                  <InputLabel id="demo-simple-select-standard-label">
                                    Select Recurring Duration
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={this.state.porecurringtype}
                                    onChange={this.handleporecurringtypeChange}
                                    label="Select Recurring Time"
                                  >
                                    {this.state.recurringtype.map(
                                      (e, index) => (
                                        <MenuItem value={e} key={index}>
                                          {e}
                                        </MenuItem>
                                      )
                                    )}
                                  </Select>
                                </FormControl>
                              </fieldset>
                              <fieldset className=" col-md-2 m-0 pl-2">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Grid container justifyContent="space-around">
                                    <DatePicker
                                      variant="inline"
                                      margin="none"
                                      id="date-picker-dialog"
                                      label="Recurring From"
                                      format="dd/MM/yyyy"
                                      minDate={new Date()}
                                      value={this.state.porecurringfrom}
                                      onChange={this.handleRecurringFrom}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="standard"
                                        />
                                      )}
                                    />
                                  </Grid>
                                </LocalizationProvider>
                              </fieldset>
                              <fieldset className=" col-md-2 m-0 pl-2">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Grid container justifyContent="space-around">
                                    <DatePicker
                                      variant="inline"
                                      margin="none"
                                      id="date-picker-dialog"
                                      label="Recurring Till"
                                      format="dd/MM/yyyy"
                                      minDate={new Date()}
                                      value={this.state.porecurringtill}
                                      onChange={this.handleRecurringTill}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="standard"
                                        />
                                      )}
                                    />
                                  </Grid>
                                </LocalizationProvider>
                              </fieldset>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                    {this.state.potype === "1" ? (
                      ""
                    ) : (
                      <div className="tw-border tw-border-dotted tw-mb-5 tw-pb-2">
                        <fieldset className="col-md-12 m-0 p-0">
                          <h3
                            className="UI-section-title"
                            style={{
                              backgroundColor: "#f4f4f4",
                              padding: "12px",
                            }}
                          >
                            Product Details
                          </h3>
                        </fieldset>
                        <div>
                          <div className="form-row p-2">
                            {this.state.orderfrom === 1 &&
                              this.state.indentitems.length !== 0 ? (
                              <TableContainer>
                                <Table className="table-sm">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Itemanme</TableCell>
                                      <TableCell>Quantity</TableCell>
                                      <TableCell>UOM</TableCell>
                                      <TableCell>Action</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.indentitems.map((e, index) => (
                                      <TableRow key={index}>
                                        <TableCell>{e.itemname}</TableCell>
                                        <TableCell>{e.quantity}</TableCell>
                                        <TableCell>{e.uom}</TableCell>
                                        <TableCell>
                                          {e.quantity === 0 ? (
                                            ""
                                          ) : (
                                            <button
                                              as="button"
                                              className="btn btn-sm hovbuttonColour"
                                              onClick={() =>
                                                this.handleIndentItem(e)
                                              }
                                            >
                                              Select
                                            </button>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            ) : (
                              ""
                            )}
                            <fieldset hidden className=" col-md-6">
                              <label>Id</label>
                              <Field
                                className="form-control"
                                type="text"
                                name="itemid"
                                placeholder="Id"
                              />
                            </fieldset>
                            <fieldset className=" col-md-12 m-0" />
                            {this.state.currency === this.state.basecurrency ||
                              this.state.currency === undefined ||
                              this.state.currency === "" ? (
                              ""
                            ) : (
                              <fieldset className=" col-md-12 m-0 text-xs">
                                <label className="text-red">
                                  Note : Please Enter/Check Convertion rate before proceeding.
                                </label>
                              </fieldset>
                            )}
                            {/* <fieldset className=" mb-4  col-md-3">
                            <FormControl variant="standard" className="w-100">
                              <InputLabel id="demo-simple-select-standard-label">
                                Closing Stock:&nbsp;
                                {this.state.inventorydata.length === 0 ? 0 : (this.state.inventorydata.reduce((a, v) => (a = a + v.currentStock), 0) - this.state.blockedsalesquantity + this.state.blockedpurchasequantity).toFixed(3)}
                              </InputLabel>
                            </FormControl>
                          </fieldset> */}

                            <fieldset className=" col-md-3">
                              <AutoCompeteField id="department" name="department" type="text" options={DepartmentList} valueKey={"name"} labelKey={"name"} value={this.state.department} label={`Select Department`} placeholder="" onChange={this.handleDepartment} disabled={this.state.grandtotal > 0 || this.state.orderfrom !== 0 || DepartmentList.length === 1} error={errors?.["department"]} />

                              {/* <Autocomplete
                              id="subaccount"
                              className="subacc-select"
                              name="department"
                              options={DepartmentList}
                              getOptionLabel={(option) => option.name}
                              value={values.department ? undefined : undefined}
                              disabled={this.state.grandtotal > 0 || this.state.orderfrom !== 0 || DepartmentList.length === 1}
                              onChange={this.handleDepartment}
                              // disabled={this.state.grandtotal!==0}
                              renderInput={(params) => (
                                <FormikTextField
                                  {...params}
                                  className="form-control"
                                  type="text"
                                  name="department"
                                  value={this.state.department}
                                  label={`Select Department (${this.state.department})`}
                                  variant="standard"
                                  fullwhidth="true"
                                  disabled={DepartmentList.length === 1}
                                />
                              )}
                            /> */}
                            </fieldset>

                            <fieldset className=" col-md-3">
                              <AutoCompeteField id="category" name="category" type="text" options={CategoryList} valueKey={"category"} labelKey={"category"} value={this.state.category} label={`Select Category`} placeholder="" onChange={this.handleCategory} disabled={this.state.orderfrom !== 0} required error={errors?.["category"]} />

                              {/* {this.state.orderfrom === 0 ? (
                              <Autocomplete
                                id="subaccount"
                                className="subacc-select"
                                name="category"
                                options={CategoryList}
                                getOptionLabel={(option) => option.category}
                                value={values.category ? undefined : undefined}
                                onChange={this.handleCategory}
                                renderInput={(params) => (
                                  <FormikTextField
                                    {...params}
                                    className="form-control"
                                    type="text"
                                    name="category"
                                    label={`Select Category (${this.state.category})`}
                                    variant="standard"
                                    fullWidth
                                  />
                                )}
                              />
                            ) : (
                              <FormikTextField
                                className="form-control"
                                type="text"
                                name="category"
                                value={this.state.category}
                                label="Category"
                                variant="standard"
                                fullWidth
                                disabled
                              />
                            )} */}
                            </fieldset>

                            <fieldset className=" col-md-3">
                              <AutoCompeteField id="itemname" name="itemname" type="text" options={filteritemlist} valueKey={"name"} labelKey={"name"} value={this.state.itemname} label={`Select Item/Product`} placeholder="" onChange={this.handleSelect} disabled={this.state.orderfrom !== 0} required error={errors?.["itemname"]} />

                              {/* {this.state.orderfrom === 0 ? (
                              <Autocomplete
                                id="subaccount"
                                className="subacc-select"
                                name="itemname"
                                options={filteritemlist}
                                getOptionLabel={(option) => option.name}
                                value={values.itemname ? undefined : undefined}
                                onChange={this.handleSelect}
                                renderInput={(params) => (
                                  <FormikTextField
                                    {...params}
                                    className="form-control"
                                    type="text"
                                    name="itemname"
                                    value={this.state.itemname}
                                    label={`Select Item (${this.state.itemname})`}
                                    variant="standard"
                                    fullWidth
                                  />
                                )}
                              />
                            ) : (
                              <FormikTextField
                                className="form-control"
                                type="text"
                                name="itemname"
                                value={this.state.itemname}
                                label="Item"
                                variant="standard"
                                fullWidth
                                disabled
                              />
                            )} */}
                            </fieldset>
                            <fieldset className=" col-md-3 ">
                              <TextfieldComponent id="cost" label={"Unit Price"} name="cost" value={this.state.cost} prefix={this.state.currency} required
                                onChange={(e) => this.setState({ cost: isInvalid.includes(e.target.value) ? 0 : e.target.value, totalprice: "", availabelcredit: this.state.creditvalue, })} error={errors?.["cost"]}
                              />
                              {/* <div className="UI-">
                              <label className="UI-label">Price</label>
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <input
                                  type="number"
                                  id="cost"
                                  className="UI-input"
                                  value={this.state.cost}
                                  onChange={(e) =>
                                    this.setState({
                                      cost:
                                        e.target.value === undefined ||
                                        e.target.value === null
                                          ? 0
                                          : e.target.value,
                                      totalprice: "",
                                      availabelcredit: this.state.creditvalue,
                                    })
                                  }
                                  onFocus={this.oncostfocus}
                                  style={{
                                    width: "100%",
                                    paddingRight: "55px",
                                  }}
                                />
                                <span
                                  style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    pointerEvents: "none",
                                    fontSize: "13px",
                                    color: "#666",
                                  }}
                                >
                                  {this.state.currency}
                                </span>
                              </div>
                            </div> */}
                            </fieldset>
                            <fieldset className=" col-md-3 ">
                              <TextfieldComponent id="quantity" label={"Quantity"} name="quantity" value={this.state.quantity} required
                                onChange={(e) =>
                                  this.setState({ quantity: isInvalid.includes(e.target.value) ? 0 : e.target.value, availabelcredit: this.state.creditvalue })}
                                error={errors?.["quantity"]}
                              />
                            </fieldset>
                            {this.state.taxrequired === true ? (
                              <>
                                <fieldset className=" col-md-3">
                                  <TextfieldComponent
                                    className="form-control"
                                    type="text"
                                    name="hsn"
                                    label="HSN Code"
                                    value={this.state.hsn}
                                    disabled
                                  />
                                </fieldset>
                                <fieldset className="form-group col-md-3">
                                  <SelectField id="tax" label={`Select Tax(%)`} list={[...this.state.taxesList.map((e => { return { ...e, description: e.tax } }))]} lableKey={"description"} lableValue={"tax"} name="tax" value={this.state.tax} onChange={(e) => this.setState({ tax: e.target.value, cgst: e.target.value / 2, sgst: e.target.value / 2, igst: e.target.value, vat: e.target.value })} />
                                </fieldset>
                                {this.state.taxtype === "GST" ? (
                                  ccountry === "India" && importpo === false ? (
                                    this.state.gsttype === "INTRASTATE" ? (
                                      <fieldset className="col-md-3 tw-flex">
                                        <fieldset className=" col-md-6">
                                          <TextfieldComponent
                                            className="form-control"
                                            type="number"
                                            name="cgst"
                                            label="CGST (%)"
                                            value={this.state.cgst}
                                            disabled
                                          />
                                        </fieldset>
                                        <fieldset className=" col-md-6">
                                          <TextfieldComponent
                                            className="form-control"
                                            type="number"
                                            name="sgst"
                                            label="SGST (%)"
                                            value={this.state.sgst}
                                            disabled
                                          />
                                        </fieldset>
                                      </fieldset>
                                    ) : (
                                      <fieldset className=" col-md-3">
                                        <TextfieldComponent
                                          className="form-control"
                                          type="number"
                                          name="tax"
                                          label="IGST (%)"
                                          value={this.state.tax}
                                          disabled
                                        />
                                      </fieldset>
                                    )
                                  ) : (
                                    <fieldset className=" col-md-3">
                                      <TextfieldComponent
                                        className="form-control"
                                        type="number"
                                        name="tax"
                                        label="GST (%)"
                                        value={this.state.tax}
                                        disabled
                                      />
                                    </fieldset>
                                  )
                                ) : (
                                  <fieldset className=" col-md-3">
                                    <TextfieldComponent
                                      className="form-control"
                                      type="number"
                                      name="tax"
                                      label="VAT (%)"
                                      value={this.state.tax}
                                      disabled
                                    />
                                  </fieldset>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                            <fieldset className=" col-md-3">
                              <TextfieldComponent
                                className="form-control "
                                type="text"
                                name="uom"
                                value={this.state.uom}
                                label="UOM"
                                variant="standard"
                                fullWidth
                                disabled
                              />
                              {/* } */}
                            </fieldset>
                            <fieldset className=" col-md-3 ">
                              <TextfieldComponent
                                className="form-control"
                                type="text"
                                name="brand"
                                label="Brand"
                                value={this.state.brand}
                                disabled
                              />
                            </fieldset>
                            <fieldset className=" col-md-3 ">
                              <TextfieldComponent
                                className="form-control"
                                type="text"
                                name="model"
                                label="Model"
                                value={this.state.model}
                                disabled
                              />
                            </fieldset>
                            {this.state.addparams === "True" ? (
                              <>
                                <fieldset className=" col-md-3">
                                  <Autocomplete
                                    id="subaccount"
                                    className="subacc-select"
                                    name="size"
                                    options={sizelist}
                                    getOptionLabel={(option) => option}
                                    value={values.size ? undefined : undefined}
                                    onChange={(e, value) => {
                                      setFieldValue("size", value);
                                    }}
                                    renderInput={(params) => (
                                      <FormikTextField
                                        {...params}
                                        className="form-control"
                                        type="text"
                                        name="size"
                                        value={this.state.size}
                                        onBlur={(e) => {
                                          this.handleSize(e.target.value, values);
                                        }}
                                        label={`Select Size (${this.state.size === null ||
                                          this.state.size === undefined
                                          ? ""
                                          : this.state.size
                                          })`}
                                        variant="standard"
                                        fullWidth
                                      />
                                    )}
                                  />
                                </fieldset>

                                <fieldset className=" col-md-3">
                                  <Autocomplete
                                    id="subaccount"
                                    className="subacc-select"
                                    name="colour"
                                    options={colourlist}
                                    getOptionLabel={(option) => option}
                                    value={values.colour ? undefined : undefined}
                                    onChange={(e, value) => {
                                      setFieldValue("colour", value);
                                    }}
                                    renderInput={(params) => (
                                      <FormikTextField
                                        {...params}
                                        className="form-control"
                                        type="text"
                                        name="colour"
                                        value={this.state.colour}
                                        onBlur={(e) => {
                                          this.handleColour(
                                            e.target.value,
                                            values
                                          );
                                        }}
                                        label={`Select Colour (${this.state.colour === null ||
                                          this.state.colour === undefined
                                          ? ""
                                          : this.state.colour
                                          })`}
                                        variant="standard"
                                        fullWidth
                                      />
                                    )}
                                  />
                                </fieldset>

                                <fieldset className=" col-md-3 ">
                                  <FormikTextField
                                    className="form-control"
                                    type="text"
                                    name="thikness"
                                    value={this.state.thickness}
                                    onChange={(e) =>
                                      this.setState({ thickness: e.target.value })
                                    }
                                    label="Thickness"
                                    variant="standard"
                                    fullWidth
                                  />
                                </fieldset>

                                <fieldset className=" col-md-3 ">
                                  <FormikTextField
                                    className="form-control"
                                    type="text"
                                    name="totalmtrroll"
                                    value={this.state.totalmtrroll}
                                    onChange={(e) =>
                                      this.setState({
                                        totalmtrroll: e.target.value,
                                      })
                                    }
                                    label="TotalMtrRoll"
                                    variant="standard"
                                    fullWidth
                                  />
                                </fieldset>
                              </>
                            ) : (
                              ""
                            )}
                            <fieldset className=" col-md-3 ">
                              <TextfieldComponent
                                className="form-control"
                                type="text"
                                name="totaprice"
                                label="Total Price"
                                value={(this.CalculateTotalPrice()
                                  ?.totalpricewtax
                                  ? this.CalculateTotalPrice()?.totalpricewtax
                                  : 0
                                ).toFixed(2)}
                                disabled={true}
                                prefix={this.state.currency}
                              />
                            </fieldset>
                            {this.state.currency !== this.state.basecurrency && (
                              <fieldset className=" col-md-3 ">
                                <TextfieldComponent
                                  className="form-control"
                                  type="text"
                                  name="totaprice"
                                  label="Total Price"
                                  value={(this.CalculateTotalPrice()
                                    ?.basetotalpricewtax
                                    ? this.CalculateTotalPrice()?.basetotalpricewtax
                                    : 0
                                  ).toFixed(2)}
                                  disabled={true}
                                  prefix={this.state.basecurrency}
                                />
                              </fieldset>
                            )}

                            <fieldset className=" col-md-12" />
                            <fieldset className="col-md-3">
                              <div className="UI-">
                                <label className="UI-label">Item For :</label>
                                <Autocomplete
                                  options={this.state.itemsfor}
                                  getOptionLabel={(option) => option.name}
                                  onChange={this.handlepoitemstatus}
                                  value={
                                    this.state.poitemstatus
                                      ? this.state.itemsfor.find(
                                        (e) => e.id === this.state.poitemstatus
                                      )
                                      : null
                                  }
                                  renderInput={(params) => (
                                    <div ref={params.InputProps.ref}>
                                      <input
                                        type="text"
                                        {...params.inputProps}
                                        className="UI-input"
                                        placeholder="Select Item For"
                                      />
                                    </div>
                                  )}
                                />
                              </div>
                            </fieldset>

                            {this.state.poitemstatus === "0" && (
                              <fieldset className="col-md-3">
                                <div className="UI-">
                                  <label className="UI-label">
                                    Internal Use For:
                                  </label>
                                  <Autocomplete
                                    options={this.state.Internalusefor}
                                    getOptionLabel={(option) => option.name}
                                    onChange={this.handleChange}
                                    value={
                                      this.state.poitemtype
                                        ? this.state.Internalusefor.find(
                                          (e) => e.id === this.state.poitemtype
                                        )
                                        : null
                                    }
                                    renderInput={(params) => (
                                      <div ref={params.InputProps.ref}>
                                        <input
                                          type="text"
                                          {...params.inputProps}
                                          className="UI-input"
                                          placeholder="Select Internal Use For"
                                        />
                                      </div>
                                    )}
                                  />
                                </div>
                              </fieldset>
                            )}
                            {this.state.poitemstatus === "0" &&
                              this.state.poitemtype === "1" && (
                                <fieldset className="col-md-3">
                                  <div className="UI-">
                                    <label className="UI-label">
                                      Asset Type :
                                    </label>
                                    <Autocomplete
                                      options={this.state.assettypes}
                                      getOptionLabel={(option) => option.name}
                                      onChange={this.handleAssetTypeChange}
                                      value={
                                        this.state.assettype
                                          ? this.state.assettypes.find(
                                            (e) => e.id === this.state.assettype
                                          )
                                          : null
                                      }
                                      renderInput={(params) => (
                                        <div ref={params.InputProps.ref}>
                                          <input
                                            type="text"
                                            {...params.inputProps}
                                            className="UI-input"
                                            placeholder="Select Internal Use For"
                                          />
                                        </div>
                                      )}
                                    />
                                  </div>
                                </fieldset>
                              )}

                            <fieldset className=" col-md-12" />
                          </div>
                          <button
                            className="btn btn-sm hovbuttonColour m-2"
                            name="totalprice"
                            type="onSubmit"
                          >
                            Add Product
                          </button>
                          {this.state.listData.length === 0 ? (
                            ""
                          ) : (
                            <TableContainer className="mt-2">
                              <Typography>
                                <fieldset className="col-md-12 m-0 p-0">
                                  <h3
                                    className="UI-section-title"
                                    style={{
                                      backgroundColor: "#f4f4f4",
                                      padding: "12px",
                                      marginBottom: "0px"
                                    }}
                                  >
                                    Products List
                                  </h3>
                                </fieldset>
                              </Typography>
                              <Table className="table-sm">
                                <TableHead>
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell></TableCell>
                                    <TableCell className="text-center">
                                      Item Name
                                    </TableCell>
                                    {this.state.taxrequired === true ? (
                                      <TableCell className="text-center">
                                        HSN
                                      </TableCell>
                                    ) : (
                                      ""
                                    )}
                                    <TableCell className="text-center">
                                      Unit Price
                                    </TableCell>
                                    {this.state.currency ===
                                      this.state.basecurrency ? (
                                      ""
                                    ) : (
                                      <TableCell className="text-center">
                                        Unit Price({this.state.currency})
                                      </TableCell>
                                    )}
                                    <TableCell className="text-center">
                                      Quantity
                                    </TableCell>
                                    <TableCell className="text-center">
                                      UOM
                                    </TableCell>
                                    <TableCell className="text-center">
                                      Item For
                                    </TableCell>
                                    <TableCell className="text-center">
                                      Total Price
                                    </TableCell>
                                    {this.state.currency ===
                                      this.state.basecurrency ? (
                                      ""
                                    ) : (
                                      <TableCell className="text-center">
                                        Total Price({this.state.currency})
                                      </TableCell>
                                    )}

                                    {this.state.taxrequired === true ? (
                                      <>
                                        {this.state.taxtype === "GST" &&
                                          ccountry === "India" ? (
                                          this.state.gsttype === "INTRASTATE" ? (
                                            <>
                                              <TableCell className="text-center">
                                                CGST
                                              </TableCell>
                                              <TableCell className="text-center">
                                                SGST
                                              </TableCell>
                                              {this.state.currency ===
                                                this.state.basecurrency ? (
                                                ""
                                              ) : (
                                                <>
                                                  {" "}
                                                  <TableCell className="text-center">
                                                    CGST(
                                                    {this.state.currency})
                                                  </TableCell>
                                                  <TableCell className="text-center">
                                                    SGST(
                                                    {this.state.currency})
                                                  </TableCell>
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <TableCell className="text-center">
                                                IGST
                                              </TableCell>
                                              {this.state.currency ===
                                                this.state.basecurrency ? (
                                                ""
                                              ) : (
                                                <TableCell className="text-center">
                                                  IGST(
                                                  {this.state.currency})
                                                </TableCell>
                                              )}
                                            </>
                                          )
                                        ) : this.state.taxtype === "GST" ? (
                                          <>
                                            <TableCell className="text-center">
                                              GST
                                            </TableCell>
                                            {this.state.currency ===
                                              this.state.basecurrency ? (
                                              ""
                                            ) : (
                                              <TableCell className="text-center">
                                                GST({this.state.currency})
                                              </TableCell>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {" "}
                                            <TableCell className="text-center">
                                              VAT
                                            </TableCell>
                                            {this.state.currency ===
                                              this.state.basecurrency ? (
                                              ""
                                            ) : (
                                              <TableCell className="text-center">
                                                VAT({this.state.currency})
                                              </TableCell>
                                            )}
                                          </>
                                        )}
                                        <TableCell className="text-center">
                                          Total Price
                                        </TableCell>
                                        {this.state.currency ===
                                          this.state.basecurrency ? (
                                          ""
                                        ) : (
                                          <TableCell className="text-center">
                                            Total Price({this.state.currency})
                                          </TableCell>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <TableCell className="text-center">
                                      Action
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {this.state.listData.map((data, index) => (
                                    <React.Fragment>
                                      <TableRow key={index}>
                                        <TableCell className="text-center">
                                          {data.parameters === 0 ? (
                                            ""
                                          ) : (
                                            <IconButton
                                              aria-label="expand row"
                                              size="small"
                                              onClick={() =>
                                                this.setState({
                                                  open: !this.state.open,
                                                })
                                              }
                                            >
                                              {this.state.open ? (
                                                <KeyboardArrowUpIcon />
                                              ) : (
                                                <KeyboardArrowDownIcon />
                                              )}
                                            </IconButton>
                                          )}
                                        </TableCell>
                                        <TableCell className="text-center">
                                          {data.name}
                                        </TableCell>
                                        {this.state.taxrequired === false ? (
                                          ""
                                        ) : (
                                          <TableCell className="text-center">
                                            {data.hsn}
                                          </TableCell>
                                        )}
                                        <TableCell className="text-right">
                                          <NumericFormat
                                            displayType={"text"}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            disabled={true}
                                            value={data.price}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                          ></NumericFormat>
                                        </TableCell>
                                        {this.state.currency ===
                                          this.state.basecurrency ? (
                                          ""
                                        ) : (
                                          <TableCell className="text-right">
                                            <NumericFormat
                                              displayType={"text"}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              value={data.ccprice}
                                              thousandSeparator={true}
                                              thousandsGroupStyle={
                                                thousandsdisplay
                                              }
                                            ></NumericFormat>
                                          </TableCell>
                                        )}
                                        <TableCell className="text-center">
                                          {data.quantity}
                                        </TableCell>
                                        <TableCell className="text-center">
                                          {data.uom}
                                        </TableCell>
                                        <TableCell className="text-center">
                                          {data.poitemstatus === "0"
                                            ? "Internal Use"
                                            : data.poitemstatus === "1"
                                              ? "Reselling"
                                              : "Raw Material"}
                                        </TableCell>
                                        <TableCell className="text-right">
                                          <NumericFormat
                                            displayType={"text"}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            disabled={true}
                                            value={data.price * data.quantity}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                          ></NumericFormat>
                                        </TableCell>
                                        {this.state.currency ===
                                          this.state.basecurrency ? (
                                          ""
                                        ) : (
                                          <TableCell className="text-right">
                                            <NumericFormat
                                              displayType={"text"}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              value={
                                                (data.price ??
                                                  data.price *
                                                  this.state
                                                    .curconversionrate) *
                                                data.quantity
                                              }
                                              thousandSeparator={true}
                                              thousandsGroupStyle={
                                                thousandsdisplay
                                              }
                                            ></NumericFormat>
                                          </TableCell>
                                        )}
                                        {this.state.taxrequired === true ? (
                                          <>
                                            {this.state.taxtype === "GST" &&
                                              this.state.gsttype ===
                                              "INTRASTATE" ? (
                                              <>
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    value={data.taxamount / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                  &nbsp;({data.tax / 2}%)
                                                </TableCell>
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    value={data.taxamount / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                  &nbsp;({data.tax / 2}%)
                                                </TableCell>
                                                {this.state.currency ===
                                                  this.state.basecurrency ? (
                                                  ""
                                                ) : (
                                                  <>
                                                    <TableCell className="text-right">
                                                      <NumericFormat
                                                        displayType={"text"}
                                                        value={
                                                          data.cctaxamount
                                                            ? data.cctaxamount / 2
                                                            : (data.taxamount /
                                                              2) *
                                                            this.state
                                                              .curconversionrate
                                                        }
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        disabled={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={
                                                          thousandsdisplay
                                                        }
                                                      ></NumericFormat>
                                                      &nbsp;({data.tax / 2}%)
                                                    </TableCell>
                                                    <TableCell className="text-right">
                                                      <NumericFormat
                                                        displayType={"text"}
                                                        value={
                                                          data.cctaxamount
                                                            ? data.cctaxamount / 2
                                                            : (data.taxamount /
                                                              2) *
                                                            this.state
                                                              .curconversionrate
                                                        }
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        disabled={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={
                                                          thousandsdisplay
                                                        }
                                                      ></NumericFormat>
                                                      &nbsp;({data.tax / 2}%)
                                                    </TableCell>
                                                  </>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    value={data.taxamount}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                  &nbsp;({data.tax}%)
                                                </TableCell>
                                                {this.state.currency ===
                                                  this.state.basecurrency ? (
                                                  ""
                                                ) : (
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      displayType={"text"}
                                                      value={
                                                        data.cctaxamount
                                                          ? data.cctaxamount
                                                          : data.taxamount *
                                                          this.state
                                                            .curconversionrate
                                                      }
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                    &nbsp;({data.tax}%)
                                                  </TableCell>
                                                )}
                                              </>
                                            )}
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                value={data.totalpricewtax}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                            {this.state.currency ===
                                              this.state.basecurrency ? (
                                              ""
                                            ) : (
                                              <TableCell className="text-right">
                                                <NumericFormat
                                                  displayType={"text"}
                                                  value={
                                                    data.cctotalpricewtax ??
                                                    data.totalpricewtax *
                                                    this.state.curconversionrate
                                                  }
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              </TableCell>
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        <TableCell className="text-center">
                                          <span
                                            as="button"
                                            data-tip
                                            data-for="delete"
                                            className="fa fa-trash text-danger cursorPointer"
                                            style={{ paddingLeft: "7px" }}
                                            onClick={() =>
                                              this.removeItemFromList(index)
                                            }
                                          ></span>
                                          {/* //<Tooltip
                                          id="delete"
                                          place="top"
                                          effect="solid"
                                        >
                                          Delete
                                        </Tooltip> */}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          style={{
                                            paddingBottom: 0,
                                            paddingTop: 0,
                                          }}
                                          colSpan={6}
                                        >
                                          <Collapse
                                            in={this.state.open}
                                            timeout="auto"
                                            unmountOnExit
                                          >
                                            <Box margin={1}>
                                              <Table
                                                size="small"
                                                aria-label="purchases"
                                              >
                                                <TableHead>
                                                  <TableRow>
                                                    <TableCell align="center">
                                                      Brand
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Colour
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Size
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      Thickness
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      TotalMtrRoll
                                                    </TableCell>
                                                    {/* <TableCell align="center">Descreption</TableCell> */}
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  <TableRow>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                      align="center"
                                                    >
                                                      {data.brand}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {data.colour}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {data.size}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {data.thickness}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {data.totalmtrroll}
                                                    </TableCell>
                                                    {/* <TableCell  align="center">{data.description}</TableCell> */}
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </Box>
                                          </Collapse>
                                        </TableCell>
                                      </TableRow>
                                    </React.Fragment>
                                  ))}
                                  <TableRow>
                                    <TableCell />
                                    <TableCell className="text-center">
                                      Total
                                    </TableCell>
                                    {this.state.taxrequired === false ? (
                                      ""
                                    ) : (
                                      <TableCell></TableCell>
                                    )}
                                    {this.state.currency ===
                                      this.state.basecurrency ? (
                                      ""
                                    ) : (
                                      <TableCell></TableCell>
                                    )}
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell className="text-right">
                                      {this.state.grandtotal === "" ? (
                                        "0"
                                      ) : (
                                        <NumericFormat
                                          displayType={"text"}
                                          value={
                                            this.state.grandtotal -
                                            this.state.totaltaxamount
                                          }
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                          disabled={true}
                                          thousandSeparator={true}
                                          thousandsGroupStyle={thousandsdisplay}
                                        ></NumericFormat>
                                      )}
                                    </TableCell>
                                    {this.state.currency ===
                                      this.state.basecurrency ? (
                                      ""
                                    ) : (
                                      <TableCell className="text-right">
                                        {this.state.grandtotal === "" ? (
                                          "0"
                                        ) : (
                                          <NumericFormat
                                            displayType={"text"}
                                            value={
                                              this.state.ccgrandtotal
                                                ? this.state.ccgrandtotal -
                                                this.state.cctotaltaxamount
                                                : (this.state.grandtotal -
                                                  this.state.totaltaxamount) *
                                                this.state.curconversionrate
                                            }
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            disabled={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                          ></NumericFormat>
                                        )}
                                      </TableCell>
                                    )}
                                    {this.state.taxrequired === true ? (
                                      <>
                                        {this.state.taxtype === "GST" &&
                                          this.state.gsttype === "INTRASTATE" ? (
                                          <>
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                value={
                                                  this.state.totaltaxamount / 2
                                                }
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                value={
                                                  this.state.totaltaxamount / 2
                                                }
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                          </>
                                        ) : (
                                          <TableCell className="text-right">
                                            <NumericFormat
                                              displayType={"text"}
                                              value={this.state.totaltaxamount}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              thousandSeparator={true}
                                              thousandsGroupStyle={
                                                thousandsdisplay
                                              }
                                            ></NumericFormat>
                                          </TableCell>
                                        )}
                                        {this.state.currency ===
                                          this.state.basecurrency ? (
                                          ""
                                        ) : (
                                          <>
                                            {this.state.taxtype === "GST" &&
                                              this.state.gsttype ===
                                              "INTRASTATE" ? (
                                              <>
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    value={
                                                      this.state.cctotaltaxamount
                                                        ? this.state
                                                          .cctotaltaxamount / 2
                                                        : (this.state
                                                          .totaltaxamount /
                                                          2) *
                                                        this.state
                                                          .curconversionrate
                                                    }
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                </TableCell>
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    value={
                                                      this.state.cctotaltaxamount
                                                        ? this.state
                                                          .cctotaltaxamount / 2
                                                        : (this.state
                                                          .totaltaxamount /
                                                          2) *
                                                        this.state
                                                          .curconversionrate
                                                    }
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                </TableCell>
                                              </>
                                            ) : (
                                              <TableCell className="text-right">
                                                <NumericFormat
                                                  displayType={"text"}
                                                  value={
                                                    this.state.cctotaltaxamount
                                                      ? this.state
                                                        .cctotaltaxamount
                                                      : this.state
                                                        .totaltaxamount *
                                                      this.state
                                                        .curconversionrate
                                                  }
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              </TableCell>
                                            )}
                                          </>
                                        )}
                                        <TableCell className="text-right">
                                          {this.state.grandtotal === "" ? (
                                            "0"
                                          ) : (
                                            <NumericFormat
                                              displayType={"text"}
                                              value={this.state.grandtotal}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              thousandSeparator={true}
                                              thousandsGroupStyle={
                                                thousandsdisplay
                                              }
                                            ></NumericFormat>
                                          )}
                                        </TableCell>
                                        {this.state.currency ===
                                          this.state.basecurrency ? (
                                          ""
                                        ) : (
                                          <TableCell className="text-right">
                                            {this.state.grandtotal === "" ? (
                                              "0"
                                            ) : (
                                              <NumericFormat
                                                displayType={"text"}
                                                value={
                                                  this.state.ccgrandtotal
                                                    ? this.state.ccgrandtotal
                                                    : this.state.grandtotal *
                                                    this.state.curconversionrate
                                                }
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            )}
                                          </TableCell>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <TableCell></TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                        </div>
                      </div>
                    )}

                    {this.state.potype === "0" ? (
                      ""
                    ) : (
                      <div className="tw-border tw-border-dootted tw-mb-5">
                        <fieldset className=" col-md-12 m-0 p-0">
                          <h3
                            className="UI-section-title"
                            style={{
                              backgroundColor: "#f4f4f4",
                              padding: "12px",
                            }}
                          >
                            Service Details
                          </h3>
                        </fieldset>
                        <div className="form-row p-2">
                          {/* {this.state.potype === "1" ? (
                            <>
                              {this.state.grandservicetotal === 0 ? (
                                <fieldset className=" col-md-6">
                                  <Autocomplete
                                    id="subaccount"
                                    className="subacc-select"
                                    name="supplier"
                                    options={suppliers}
                                    getOptionLabel={(option) =>
                                      option.companyname
                                    }
                                    value={
                                      values.supplier ? undefined : undefined
                                    }
                                    onChange={this.handlesupplier}
                                    renderInput={(params) => (
                                      <FormikTextField
                                        {...params}
                                        className="form-control"
                                        type="text"
                                        name="supplier"
                                        value={this.state.supplier}
                                        label={`Select  Supplier(${this.state.supplier})`}
                                        variant="standard"
                                        fullWidth
                                      />
                                    )}
                                  />
                                </fieldset>
                              ) : (
                                <fieldset
                                  className=" col-md-6"
                                  disabled
                                >
                                  <FormikTextField
                                    className="form-control"
                                    type="text"
                                    name="supplier"
                                    value={this.state.supplier}
                                    label="Supplier"
                                    variant="standard"
                                    fullWidth
                                  />
                                </fieldset>
                              )}
                            </>
                          ) : (
                            ""
                          )} */}

                          {this.state.potype === "1" &&
                            <fieldset className=" col-md-3">
                              <AutoCompeteField id="contracttype" name="contracttype" type="text" options={contracttypeList} valueKey={null} labelKey={null} value={this.state.contracttype} label={`Select Contract Type`} placeholder="" onChange={(e, value) => { setFieldValue("contracttype", value); this.setState({ contracttype: value }) }} disabled={this.state.serviceList.length > 0} error={errors?.["contracttype"]} />
                            </fieldset>}

                          <fieldset className=" col-md-3">
                            <AutoCompeteField id="department" name="department" type="text" options={DepartmentList} valueKey={"name"} labelKey={"name"} value={this.state.department} label={`Select Department`} placeholder="" onChange={this.handleDepartment} disabled={this.state.grandtotal > 0 || this.state.orderfrom !== 0 || DepartmentList.length === 1} error={errors?.["department"]} />
                          </fieldset>

                          <fieldset className=" col-md-3">
                            <AutoCompeteField id="servicecategory" name="servicecategory" type="text" options={ServiceCategoryList} valueKey={"category"} labelKey={"category"} value={this.state.servicecategory} label={`Select Service Category`} placeholder="" onChange={this.handleServicecategory} error={errors?.["servicecategory"]} />

                            {/* <Autocomplete
                              id="subaccount"
                              className="subacc-select"
                              name="servicecategory"
                              options={ServiceCategoryList}
                              getOptionLabel={(option) => option.category}
                              value={
                                values.servicecategory ? undefined : undefined
                              }
                              onChange={(e, value) => {
                                setFieldValue("servicecategory", value);
                              }}
                              renderInput={(params) => (
                                <FormikTextField
                                  {...params}
                                  className="form-control"
                                  type="text"
                                  name="servicecategory"
                                  onBlur={(e) => {
                                    this.handleServicecategory(
                                      e.target.value,
                                      values
                                    );
                                  }}
                                  label="Select Service Category"
                                  variant="standard"
                                  fullWidth
                                />
                              )}
                            /> */}
                          </fieldset>

                          <fieldset className=" col-md-3">
                            <AutoCompeteField id="service" name="service" type="text" options={filterserv} valueKey={"service"} labelKey={"service"} value={this.state.service} label={`Select Service`} placeholder="" onChange={this.handleService} error={errors?.["service"]} />

                          </fieldset>
                          <fieldset className=" col-md-3">
                            {/* <FormikTextField
                              id="samount"
                              className="form-control"
                              type="number"
                              name="servicecost"
                              label="Amount"
                              onChange={this.handleServiceAmountChange}
                              onFocus={this.onsamountfocus}
                              // onBlur={(e)=>setFieldValue(`servicecostwttax`,parseFloat(e.target.value)+((servicetax/100)*parseInt(e.target.value)))}
                            /> */}
                            <TextfieldComponent id="samount" name="samount" label="Amount" onChange={this.handleServiceAmountChange} value={this.state.servicecost} prefix={this.state.currency} error={errors?.["servicecost"]} />
                          </fieldset>
                          <fieldset className=" col-md-3 ">
                            {/*  <div className="UI-">
                              <label className="UI-label">Quantity</label>
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <input
                                  type="number"
                                  id="quantity"
                                  className="UI-input"
                                  value={this.state.quantity}
                                  onChange={(e) =>
                                    this.setState({
                                      quantity:e.target.value === undefined || e.target.value === null? 0 : e.target.value,
                                      availabelcredit: this.state.creditvalue,
                                    })
                                  }
                                  onFocus={this.onquantityfocus}
                                  style={{
                                    width: "100%",
                                    paddingRight: "55px",
                                  }}
                                />
                              </div>
                            </div> */}
                            <TextfieldComponent id="quantity" name="quantity" label="Quantity"
                              onChange={(e) =>
                                this.setState({
                                  quantity: isInvalid.includes(e.target.value) ? 0 : e.target.value,
                                  availabelcredit: this.state.creditvalue,
                                })
                              } value={this.state.quantity} />
                          </fieldset>
                          {this.state.taxrequired === true && (
                            <fieldset className=" col-md-3">
                              <TextfieldComponent name={"servicecode"} id="servicecode" label={`Service Code`} value={this.state.servicecode} disabled={true} />
                            </fieldset>
                          )}
                          {this.state.taxrequired === true ? (
                            <>
                              <fieldset className="form-group col-md-3">
                                <SelectField id="tax" label={`Select Tax(%)`} list={[...this.state.taxesList.map((e => { return { ...e, description: e.tax } }))]} lableKey={"description"} lableValue={"tax"} name="tax" value={this.state.servicetax} onChange={(e) => this.setState({ servicetax: e.target.value, serviceigst: e.target.value, servicecgst: e.target.value / 2, servicesgst: e.target.value / 2, servicegst: e.target.value, servicevat: e.target.value })} />
                              </fieldset>
                              {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? <>
                                <fieldset className=" col-md-3">
                                  {/* <FormikTextField
                                              className="form-control"
                                              type="number"
                                              name="servicecgst"
                                              label={`CGST (${this.state.servicetax === ""? 0: this.state.servicetax / 2}%)`}
                                              value={this.state.servicecgst}
                                              disabled
                                            /> */}
                                  <TextfieldComponent id="servicecgst" name="servicecgst" label={`CGST (${this.state.servicetax === "" ? 0 : this.state.servicetax / 2}%)`} value={this.CalculateServicePrices()?.servicecgst} prefix={this.state.currency} disabled={true} />
                                </fieldset>
                                <fieldset className=" col-md-3">
                                  {/* <FormikTextField
                                              className="form-control"
                                              type="number"
                                              name="servicesgst"
                                              label={`SGST (${
                                                this.state.servicetax === ""
                                                  ? 0
                                                  : this.state.servicetax / 2
                                              }%)`}
                                              value={this.state.servicesgst}
                                              disabled
                                            /> */}
                                  <TextfieldComponent id="servicesgst" name="servicesgst"
                                    label={`SGST (${this.state.servicetax === "" ? 0 : this.state.servicetax / 2}%)`}
                                    value={this.CalculateServicePrices()?.servicesgst} prefix={this.state.currency} disabled={true} />
                                </fieldset>
                              </>
                                :
                                <fieldset className=" col-md-3">
                                  {/* <FormikTextField
                                              className="form-control"
                                              type="number"
                                              name="servicesgst"
                                              label={`SGST (${
                                                this.state.servicetax === ""
                                                  ? 0
                                                  : this.state.servicetax / 2
                                              }%)`}
                                              value={this.state.servicesgst}
                                              disabled
                                            /> */}
                                  <TextfieldComponent id="servicetax" name="servicetax"
                                    label={`${this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype !== "INTRASTATE" ? "IGST" : this.state.taxtype} (${this.state.servicetax === "" ? 0 : this.state.servicetax}%)`}
                                    value={this.CalculateServicePrices()?.servicetaxamount} prefix={this.state.currency} disabled={true} />
                                </fieldset>}
                            </>
                          ) : (
                            ""
                          )}
                          <fieldset className=" col-md-3">
                            {/* <FormikTextField
                                className="form-control"
                                type="number"
                                name="servicecostwttax"
                                label="Total Amount"
                                value={this.state.servicecostwttax}
                                disabled
                              /> */}
                            <TextfieldComponent id="servicecostwttax" name="servicecostwttax" label={"Total Amount"} value={this.CalculateServicePrices()?.servicecostwttax} prefix={this.state.currency} disabled={true} />
                          </fieldset>
                          {this.state.currency !== this.state.basecurrency && <fieldset className=" col-md-3">
                            <TextfieldComponent id="servicecostwttax" name="baseservicecostwttax" label={"Total Amount"} value={this.CalculateServicePrices()?.baseservicecostwttax} prefix={this.state.basecurrency} disabled={true} />
                          </fieldset>}

                          {this.state.potype === "1" ? (
                            <>

                              {this.state.contracttype === "Recurring" && (
                                <>
                                  <fieldset className=" col-md-3">
                                    <Autocomplete
                                      id="subaccount"
                                      className="subacc-select"
                                      name="contracttime"
                                      options={recurringtype}
                                      getOptionLabel={(option) => option}
                                      value={this.state.contracttime ? recurringtype.find(e => e === this.state.contracttime) : null}
                                      onChange={(e, value) => {
                                        // setFieldValue("contracttime", value);
                                        this.setState({
                                          contracttime: e.target.value,
                                        });
                                      }}
                                      renderInput={(params) => (
                                        <FormikTextField
                                          {...params}
                                          className="form-control"
                                          type="text"
                                          name="contracttime"
                                          label="Select Contract Time"
                                          variant="standard"
                                          fullWidth
                                        />
                                      )}
                                    />
                                  </fieldset>

                                  <fieldset className=" col-md-3" />
                                  <fieldset className="mr-4">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Grid
                                        container
                                        justifyContent="space-around"
                                      >
                                        <DatePicker
                                          variant="inline"
                                          margin="normal"
                                          id="date-picker-dialog"
                                          label="Start Date"
                                          format="dd/MM/yyyy"
                                          minDate={new Date()}
                                          value={this.state.contractstartdate}
                                          onChange={this.handleStartDateChange}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              variant="standard"
                                            />
                                          )}
                                        />
                                      </Grid>
                                    </LocalizationProvider>
                                  </fieldset>
                                  <fieldset>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <Grid
                                        container
                                        justifyContent="space-around"
                                      >
                                        <DatePicker
                                          variant="inline"
                                          margin="normal"
                                          id="date-picker-dialog"
                                          label="End Date"
                                          format="dd/MM/yyyy"
                                          minDate={new Date()}
                                          value={this.state.contractenddate}
                                          onChange={this.handleEndDateChange}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              variant="standard"
                                            />
                                          )}
                                        />
                                      </Grid>
                                    </LocalizationProvider>
                                  </fieldset>
                                </>
                              )}
                              {/* <fieldset className=" col-md-12  mt-3 mb-5">
                                <FormikTextField
                                  name="description"
                                  className="form-control"
                                  multiline
                                  rows={2}
                                  label="Description"
                                  variant="outlined"
                                  value={this.state.servicedescription}
                                  onChange={(e) =>
                                    this.setState({
                                      servicedescription: e.target.value,
                                    })
                                  }
                                />
                              </fieldset> */}
                              {this.state.contracttype === "Milestone" ? (
                                <>
                                  <div className=" col-md-12 mt-2">
                                    <Accordion className="tw-overflow-hidden" defaultExpanded>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{ backgroundColor: "#e8ecef" }}
                                      >
                                        <Typography>Milestones</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <FieldArray
                                          name="milestone"
                                          render={(arrayHelpers) => (
                                            <div className=" col-md-12">
                                              {values.milestone.map(
                                                (data, index) => (
                                                  <div
                                                    key={index}
                                                    className="form-row"
                                                  >
                                                    {/** both these conventions do the same */}
                                                    <fieldset className=" col-md-2">
                                                      <FormikTextField
                                                        className="form-control"
                                                        name={`milestone[${index}].name`}
                                                        label="Name"
                                                        variant="standard"
                                                        // onChange={() =>
                                                        //   this.setState({
                                                        //     milestonesavebtn: false,
                                                        //   })
                                                        // }
                                                        fullWidth
                                                      />
                                                    </fieldset>
                                                    <fieldset className=" col-md-2 ">
                                                      <FormikTextField
                                                        className="form-control"
                                                        id="amount"
                                                        type="number"
                                                        min={1}
                                                        max={100}
                                                        name={`milestone.${index}.percentage`}
                                                        label="Percentage (%)"
                                                        variant="standard"
                                                        // onChange={() =>
                                                        //   this.setState({
                                                        //     milestonesavebtn: false,
                                                        //   })
                                                        // }
                                                        onBlur={() =>
                                                          setFieldValue(
                                                            `milestone.${index}.amountwttax`,
                                                            (data.percentage /
                                                              100) *
                                                            (parseFloat(
                                                              this.state
                                                                .servicecost
                                                            ) +
                                                              (servicetax /
                                                                100) *
                                                              parseFloat(
                                                                this.state
                                                                  .servicecost
                                                              ))
                                                          ) &&
                                                          setFieldValue(
                                                            `milestone.${index}.amount`,
                                                            (data.percentage /
                                                              100) *
                                                            parseFloat(
                                                              this.state
                                                                .servicecost
                                                            )
                                                          )
                                                        }
                                                        onFocus={this.onfocus}
                                                        fullWidth
                                                      />
                                                    </fieldset>
                                                    <fieldset className=" col-md-2">
                                                      <FormikTextField
                                                        className="form-control"
                                                        type="number"
                                                        name={`milestone.${index}.amount`}
                                                        label="Amount"
                                                        variant="standard"
                                                        fullWidth
                                                        disabled
                                                      ></FormikTextField>
                                                    </fieldset>
                                                    <fieldset className=" col-md-2">
                                                      <FormikTextField
                                                        className="form-control"
                                                        type="number"
                                                        name={`milestone.${index}.amountwttax`}
                                                        label="Amount inc.Tax"
                                                        variant="standard"
                                                        fullWidth
                                                        disabled
                                                      ></FormikTextField>
                                                    </fieldset>
                                                    <fieldset className=" col-md-3">
                                                      <FormikTextField
                                                        id="date"
                                                        label="Expected Date"
                                                        name={`milestone.${index}.expecteddate`}
                                                        type="date"
                                                        minDate={new Date()}
                                                        // onChange={() =>
                                                        //   this.setState({
                                                        //     milestonesavebtn: false,
                                                        //   })
                                                        // }
                                                        className={
                                                          useStyles.textField
                                                        }
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                      />
                                                    </fieldset>
                                                    {values.milestone.length !==
                                                      1 ? (
                                                      <span
                                                        as="button"
                                                        className="fa fa-minus-square btn btn-sm hovbuttonColour text-danger mt-4"
                                                        onClick={() =>
                                                          arrayHelpers.remove(
                                                            index
                                                          )
                                                        }
                                                      ></span>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <span
                                                      as="button"
                                                      className="fa fa-plus-square text-info mt-4 ml-3"
                                                      onClick={() =>
                                                        arrayHelpers.push({
                                                          name: "",
                                                          expecteddate: "",
                                                          percentage: 0,
                                                          amount: 0,
                                                          amountwttax: 0,
                                                        })
                                                      }
                                                    ></span>
                                                  </div>
                                                )
                                              )}
                                              <p
                                                className={`${this.state
                                                  .percentagemessage ===
                                                  "Milestones Saved Scussesfully"
                                                  ? "text-green"
                                                  : "text-danger"
                                                  }`}
                                              >
                                                {this.state.percentagemessage}
                                              </p>
                                              <span
                                                as="button"
                                                className="btn btn-sm float-right"
                                                onClick={() =>
                                                  this.handlemilestonevalues(
                                                    values.milestone
                                                  )
                                                }
                                              >
                                                <i
                                                  className={`${this.state
                                                    .milestonesavebtn ===
                                                    false
                                                    ? "fa fa-save"
                                                    : "fa fa-check text-green"
                                                    } mr-1`}
                                                />
                                                Save
                                              </span>
                                            </div>
                                          )}
                                        />
                                      </AccordionDetails>
                                    </Accordion>
                                    {/* <fieldset className=" col-md-3 mt-3">
                                      Advance Payment :
                                      <FormControlLabel
                                        className="ml-2"
                                        control={
                                          <Checkbox
                                            className="sm"
                                            checked={this.state.advancestatus}
                                            onChange={this.handleadvancestatus}
                                            name="checkedB"
                                          />
                                        }
                                      />
                                    </fieldset>
                                    {this.state.advancestatus && <>
                                      {this.state.currency !== this.state.basecurrency && 
                                      <fieldset className=" col-md-2">
                                      <TextfieldComponent id={"ccadvance"} label={"Advance Amount"} value={this.state.ccadvance} onChange={(e)=>this.handleAdvanceChange(e.target.value?parseFloat(e.target.value)*this.state.curconversionrate:0)} prefix={this.state.currency}/>
                                    </fieldset>}
                                    <fieldset className=" col-md-3">
                                        <TextfieldComponent id={"advance"} label={"Advance Amount"} onChange={(e)=>this.handleAdvanceChange(e.target.value)} value={this.state.advance} prefix={this.state.basecurrency} disabled={this.state.currency !== this.state.basecurrency}/>
                                      </fieldset>
                                    </>} */}
                                    {this.state.milestone.length === 0 ? (
                                      ""
                                    ) : (
                                      <TableContainer>
                                        <Table className="table-sm mt-4">
                                          <TableHead>
                                            <TableRow>MileStones</TableRow>
                                          </TableHead>
                                          <TableHead className="text-sm">
                                            <TableRow
                                              style={{ textAlign: "center" }}
                                            >
                                              <TableCell className="text-center">
                                                Name
                                              </TableCell>
                                              <TableCell className="text-center">
                                                Expected&nbsp;Date
                                              </TableCell>
                                              <TableCell className="text-center">
                                                Percentage
                                              </TableCell>
                                              <TableCell className="text-center">
                                                Amount
                                              </TableCell>
                                              {this.state.currency ===
                                                this.state.basecurrency ? (
                                                ""
                                              ) : (
                                                <TableCell className="text-center">
                                                  Amount ({this.state.currency})
                                                </TableCell>
                                              )}
                                              <TableCell className="text-center">
                                                Total
                                              </TableCell>
                                              {this.state.currency ===
                                                this.state.basecurrency ? (
                                                ""
                                              ) : (
                                                <TableCell className="text-center">
                                                  Total ({this.state.currency})
                                                </TableCell>
                                              )}
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {this.state.milestone.map(
                                              (data, index) => (
                                                <TableRow key={index}>
                                                  <TableCell className="text-center">
                                                    {data.name}
                                                  </TableCell>
                                                  <TableCell className="text-center">
                                                    {moment(
                                                      data.expecteddate
                                                    ).format("DD-MM-YYYY")}
                                                  </TableCell>
                                                  <TableCell className="text-center">
                                                    {data.percentage}
                                                  </TableCell>
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      className="pr-3"
                                                      displayType={"text"}
                                                      value={data.amount}
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                  </TableCell>
                                                  {this.state.currency ===
                                                    this.state.basecurrency ? (
                                                    ""
                                                  ) : (
                                                    <TableCell className="text-right">
                                                      <NumericFormat
                                                        className="pr-3"
                                                        displayType={"text"}
                                                        value={
                                                          data.amount *
                                                          this.state
                                                            .curconversionrate
                                                        }
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        disabled={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={
                                                          thousandsdisplay
                                                        }
                                                      ></NumericFormat>
                                                    </TableCell>
                                                  )}
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      className="pr-3"
                                                      displayType={"text"}
                                                      value={data.amountwttax}
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                  </TableCell>
                                                  {this.state.currency ===
                                                    this.state.basecurrency ? (
                                                    ""
                                                  ) : (
                                                    <TableCell className="text-right">
                                                      <NumericFormat
                                                        className="pr-3"
                                                        displayType={"text"}
                                                        value={
                                                          data.amountwttax *
                                                          this.state
                                                            .curconversionrate
                                                        }
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        disabled={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={
                                                          thousandsdisplay
                                                        }
                                                      ></NumericFormat>
                                                    </TableCell>
                                                  )}
                                                </TableRow>
                                              )
                                            )}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    )}
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                              <fieldset className=" col-md-12" />
                            </>
                          ) : (
                            ""
                          )}
                          {this.state.potype === "1" && this.state.contracttype === "Milestone" ? (
                            ""
                          ) : (
                            <>
                              <fieldset className=" col-md-12">
                                {/* <FormikTextField
                                  name="description"
                                  className="form-control"
                                  multiline
                                  rows={2}
                                  label="Description"
                                  variant="outlined"
                                  value={this.state.servicedescription}
                                  onChange={(e) =>
                                    this.setState({
                                      servicedescription: e.target.value,
                                    })
                                  }
                                /> */}
                                <TextareaField name="servicedescription" className="form-control" multiline rows={2} maxLength={100} label="Description" value={this.state.servicedescription} onChange={(e) => this.setState({ servicedescription: e.target.value })} required error={errors?.["servicedescription"]} />
                              </fieldset>
                              <button
                                type="button"
                                className="btn btn-sm hovbuttonColour shadow-sm text-white"
                                // onClick={()=>{this.handleaddService}
                                onClick={async () => {
                                  const errors = await validateForm("service");
                                  if (Object.keys(errors).length === 0) {
                                    this.handleaddService()
                                  }
                                }}
                              >
                                Add Service
                              </button>

                              <div className=" col-md-12 text-red text-sm">
                                {this.state.serviceerr}
                              </div>
                              {this.state.serviceList && this.state.serviceList.length > 0 &&
                                <TableContainer className="mt-2">
                                  <Typography>
                                    <h3
                                      className="UI-section-title"
                                      style={{
                                        backgroundColor: "#f4f4f4",
                                        padding: "12px",
                                        marginBottom: "0px"
                                      }}
                                    >
                                      Services List
                                    </h3>
                                  </Typography>
                                  <Table className="table-sm">
                                    <TableHead>
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell className="text-center">
                                          Service
                                        </TableCell>
                                        <TableCell className="text-center">
                                          Service Category
                                        </TableCell>
                                        <TableCell className="text-center">
                                          Service Cost
                                        </TableCell>
                                        {this.state.currency !==
                                          this.state.basecurrency && (
                                            <TableCell className="text-center">
                                              Service Cost ({this.state.currency})
                                            </TableCell>
                                          )}
                                        {this.state.taxrequired === true ? (
                                          <>
                                            {this.state.taxtype === "GST" ? (
                                              ccountry === "India" ? (
                                                this.state.gsttype ===
                                                  "INTRASTATE" ? (
                                                  <>
                                                    <TableCell className="text-center">
                                                      CGST (%)
                                                    </TableCell>
                                                    <TableCell className="text-center">
                                                      SGST (%)
                                                    </TableCell>
                                                  </>
                                                ) : (
                                                  <TableCell className="text-center">
                                                    IGST (%)
                                                  </TableCell>
                                                )
                                              ) : (
                                                <TableCell className="text-center">
                                                  GST (%)
                                                </TableCell>
                                              )
                                            ) : (
                                              <TableCell className="text-center">
                                                VAT (%)
                                              </TableCell>
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        <TableCell className="text-center">
                                          Service Description
                                        </TableCell>
                                        <TableCell className="text-center">
                                          Service Total
                                        </TableCell>
                                        {this.state.currency !==
                                          this.state.basecurrency && (
                                            <TableCell className="text-center">
                                              Service Total ({this.state.currency})
                                            </TableCell>
                                          )}
                                        <TableCell className="text-center">
                                          Action
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {this.state.serviceList.map(
                                        (data, index) => (
                                          <TableRow key={index}>
                                            <TableCell className="text-center">
                                              {data.service}
                                            </TableCell>
                                            <TableCell className="text-center">
                                              {data.servicecategory}
                                            </TableCell>
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                value={data.servicecost}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                            {this.state.currency !==
                                              this.state.basecurrency && (
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    value={data.ccservicecost}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                </TableCell>
                                              )}

                                            {this.state.taxrequired === true ? (
                                              <>
                                                {this.state.taxtype === "GST" ? (
                                                  ccountry === "India" ? (
                                                    this.state.gsttype ===
                                                      "INTRASTATE" ? (
                                                      <>
                                                        <TableCell className="text-center">
                                                          {this.state.servicecgst}
                                                        </TableCell>
                                                        <TableCell className="text-center">
                                                          {this.state.servicesgst}
                                                        </TableCell>
                                                      </>
                                                    ) : (
                                                      <TableCell className="text-center">
                                                        {this.state.serviceigst}
                                                      </TableCell>
                                                    )
                                                  ) : (
                                                    <TableCell className="text-center">
                                                      {this.state.servicegst}
                                                    </TableCell>
                                                  )
                                                ) : (
                                                  <TableCell className="text-center">
                                                    {this.state.servicevat}
                                                  </TableCell>
                                                )}
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            <TableCell className="text-center">
                                              {data.servicedescription}
                                            </TableCell>
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                value={data.servicetotalwtax}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                            {this.state.currency !== this.state.basecurrency &&
                                              <TableCell className="text-right">
                                                <NumericFormat
                                                  displayType={"text"}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  value={data.ccservicetotalwtax}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              </TableCell>
                                            }
                                            <TableCell className="text-center">
                                              <span
                                                as="button"
                                                data-tip
                                                data-for="delete"
                                                className="fa fa-trash text-danger tw-cursor-pointer"
                                                style={{ paddingLeft: "7px" }}
                                                onClick={() =>
                                                  this.removeServiceFromList(
                                                    index
                                                  )
                                                }
                                              ></span>
                                              {/* //<Tooltip
                                              id="delete"
                                              place="top"
                                              effect="solid"
                                            >
                                              Delete
                                            </Tooltip> */}
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell></TableCell>
                                        {this.state.currency !== this.state.basecurrency && <TableCell></TableCell>}
                                        {this.state.taxrequired === true ? (
                                          <>
                                            {this.state.taxtype === "GST" ? (
                                              ccountry === "India" ? (
                                                this.state.gsttype ===
                                                  "INTRASTATE" ? (
                                                  <>
                                                    <TableCell className="text-center"></TableCell>
                                                    <TableCell className="text-center"></TableCell>
                                                  </>
                                                ) : (
                                                  <TableCell className="text-center"></TableCell>
                                                )
                                              ) : (
                                                <TableCell className="text-center"></TableCell>
                                              )
                                            ) : (
                                              <TableCell className="text-center"></TableCell>
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell className="text-right">
                                          {this.state.grandservicetotal === "" ? (
                                            0
                                          ) : (
                                            <NumericFormat
                                              displayType={"text"}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              value={this.state.grandservicetotal}
                                              thousandSeparator={true}
                                              thousandsGroupStyle={
                                                thousandsdisplay
                                              }
                                            ></NumericFormat>
                                          )}
                                        </TableCell>
                                        {this.state.currency !== this.state.basecurrency &&
                                          <TableCell className="text-right">
                                            {this.state.ccgrandservicetotal === "" ? (
                                              0
                                            ) : (
                                              <NumericFormat
                                                displayType={"text"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                value={this.state.ccgrandservicetotal}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            )}
                                          </TableCell>}
                                        <TableCell></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>}
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    <fieldset className=" col-md-12" />

                    <div className=" col-md-12 tw-border tw-border-dotted tw-mb-5 tw-p-0 tw-pb-2" >
                      <fieldset className="col-md-12 m-0 p-0">
                        <h3
                          className="UI-section-title"
                          style={{
                            backgroundColor: "#f4f4f4",
                            padding: "12px",
                          }}
                        >
                          Other Details
                        </h3>
                      </fieldset>
                      <div className="form-row px-2">
                        {(this.state.openingbalance !== null &&
                          this.state.openingbalance !== undefined &&
                          this.state.openingbalance > 0) ||
                          (this.state.creditamount !== null &&
                            this.state.creditamount !== undefined &&
                            this.state.creditamount > 0) ? (
                          <FormLabel
                            id="demo-row-radio-buttons-group-label"
                            className="mt-2"
                          >
                            Adjust Amount From :
                          </FormLabel>
                        ) : (
                          ""
                        )}
                        {this.state.openingbalance !== null &&
                          this.state.openingbalance !== undefined &&
                          this.state.openingbalance > 0 ? (
                          <>
                            <FormGroup row>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.adjustopen}
                                    onChange={() =>
                                      this.setState({
                                        adjustopen: !this.state.adjustopen,
                                      })
                                    }
                                    name="adjustopen"
                                    color="primary"
                                  />
                                }
                                // disabled={this.state.openingbalance>(this.state.grandtotal - this.state.totaltaxamount)}
                                label={`Opening Balance (${this.state.openingbalance})`}
                              />
                            </FormGroup>
                          </>
                        ) : (
                          ""
                        )}

                        {this.state.creditamount !== null &&
                          this.state.creditamount !== undefined &&
                          this.state.creditamount > 0 ? (
                          <>
                            <FormGroup row>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.adjustcredit}
                                    onChange={() =>
                                      this.setState({
                                        adjustcredit: !this.state.adjustcredit,
                                      })
                                    }
                                    name="adjustcredit"
                                    color="primary"
                                  />
                                }
                                label={`Debit Amount (${this.state.creditamount})`}
                              />
                            </FormGroup>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* <div className="form-row px-2">
                      <fieldset className=" col-md-3">
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.customPOdate}
                                onChange={this.handlecustomPODate}
                                name="ordertype"
                                color="primary"
                              />
                            }
                            label="PO creation date"
                          />
                        </FormGroup>
                      </fieldset>

                      <fieldset className=" col-md-3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Grid justifyContent="space-around">
                            <DateTimePicker
                              disableFuture
                              showtodaybutton
                              showcancelbutton
                              //  views={["year", "month","date"]}
                              variant="inline"
                              id="date-picker-dialog"
                              // label="Financial Year Start Date"
                              // inputVariant="outlined"
                              minDate={
                                new Date(
                                  moment(transactionFrom).format("YYYY-MM-DD")
                                )
                              }
                              maxDate={new Date()}
                              label={`PO Creation Date : ${
                                this.state.customPOdate ? "Custom" : "Default"
                              }`}
                              format="dd/MM/yyyy HH:mm"
                              value={this.state.createdAt}
                              InputAdornmentProps={{ position: "start" }}
                              onChange={this.handlecreatedAtDateChange}
                              renderInput={(params) => (
                                <TextField {...params} variant="standard" />
                              )}
                              autoOk={true}
                              fullWidth
                              disabled={this.state.customPOdate === false}
                            />
                          </Grid>
                        </LocalizationProvider>
                      </fieldset>
                    </div> */}
                      <div className="form-row mt-2 tw-ml-3">
                        <fieldset className=" col-md-4 m-0 text-md">
                          <Box sx={{ width: 250 }}>
                            <Typography id="input-slider" gutterBottom>
                              Payment Terms : ({this.state.paymentterms}) Days
                            </Typography>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs>
                                <Slider
                                  value={
                                    typeof this.state.paymentterms ===
                                      "number"
                                      ? this.state.paymentterms
                                      : 0
                                  }
                                  onChange={this.handleSliderChange}
                                  aria-labelledby="input-slider"
                                  min={0}
                                  max={120}
                                  style={{ color: "#152f5f" }}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </fieldset>
                      </div>
                      <div className="form-row px-2">
                        <fieldset className=" col-md-4 m-0">
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.advancestatus}
                                  onChange={this.handleadvancestatus}
                                  name="ordertype"
                                  color="primary"
                                />
                              }
                              label="Advance Payment Required?"
                            />
                          </FormGroup>
                        </fieldset>
                        {this.state.advancestatus && <>
                          {this.state.currency !== this.state.basecurrency &&
                            <fieldset className=" col-md-2">
                              <TextfieldComponent id={"ccadvance"} label={"Advance Amount"} value={this.state.ccadvance} onChange={(e) => this.handleAdvanceChange(e.target.value ? parseFloat(e.target.value) * this.state.curconversionrate : 0)} prefix={this.state.currency} />
                            </fieldset>}
                          <fieldset className=" col-md-2 m-0">
                            <TextfieldComponent id={"advanceamount"} label={"Advance Amount"} onChange={(e) => this.handleAdvanceChange(e.target.value)} value={this.state.advance} prefix={this.state.basecurrency} disabled={this.state.currency !== this.state.currency} />
                          </fieldset>
                        </>}
                      </div>
                      <div className="form-row px-2">
                        <fieldset className=" col-md-4 m-0">
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.tcsreq}
                                  onChange={this.handletcsreq}
                                  name="ordertype"
                                  color="primary"
                                />
                              }
                              label="TCS Required?"
                            />
                          </FormGroup>
                        </fieldset>
                        {this.state.tcsreq === true ? (
                          <>
                            <fieldset className=" col-md-2">
                              {/* <TextField
                              className="form-control"
                              id="tcsableamount"
                              name="tcsableamount"
                              type="number"
                              label={`TCS on Amount`}
                              value={this.state.tcsableamount}
                              variant="standard"
                              fullwhidth="true"
                              onChange={(e) =>
                                this.setState({
                                  tcsableamount: e.target.value,
                                  tcsamount: (
                                    (this.state.tcs * e.target.value) /
                                    100
                                  ).toFixed(3),
                                })
                              }
                            /> */}
                              <TextfieldComponent id={"tcsableamount"} label={"TCS on Amount"} value={this.state.tcsableamount} prefix={this.state.currency}
                                onChange={(e) =>
                                  this.setState({
                                    tcsableamount: e.target.value,
                                    tcsamount: (
                                      (this.state.tcs * e.target.value) /
                                      100
                                    ).toFixed(3),
                                  })
                                } />

                            </fieldset>
                            <fieldset className=" col-md-2">
                              {/* <FormikTextField
                              className="form-control"
                              type="number"
                              name="tcs"
                              onChange={this.handletcsChange}
                              label={`TCS (%)`}
                              value={this.state.tcs}
                              variant="standard"
                              fullWidth
                            /> */}
                              <TextfieldComponent id={"tcs"} label={"TCS (%)"} value={this.state.tcs} onChange={this.handletcsChange} prefix={"%"} />

                            </fieldset>
                            <fieldset className=" col-md-2">
                              {/* <FormikTextField
                              className="form-control"
                              type="number"
                              name="tcsamount"
                              label="TCS Amount"
                              value={this.state.tcsamount}
                              variant="standard"
                              fullWidth
                              disabled
                            /> */}
                              <TextfieldComponent id={"tcsamount"} label={"TCS Amount"} value={this.state.tcsamount} prefix={this.state.currency} disabled />

                            </fieldset>
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-row px-2">
                        <fieldset className=" col-md-4 m-0">
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.reqquotationupload}
                                  onChange={() =>
                                    this.setState({
                                      reqquotationupload:
                                        !this.state.reqquotationupload,
                                    })
                                  }
                                  name="reqquotationupload"
                                  color="primary"
                                />
                              }
                              label="Upload Quotation/Ref Doc"
                            />
                          </FormGroup>
                        </fieldset>
                        {this.state.reqquotationupload === false ? (
                          ""
                        ) : this.state.file === "" ? (
                          <>
                            <fieldset className=" col-md-4 m-0">
                              {/* <span>Quotation File upload :&nbsp;&nbsp;</span> */}
                              {!selectedFiles ? (
                                <label htmlFor="btn-upload">
                                  <input
                                    className="btn-choose"
                                    id="btn-upload"
                                    name="btn-upload"
                                    style={{ display: "none" }}
                                    type="file"
                                    onChange={this.selectFile}
                                  />
                                  <Button
                                    className="btn-close"
                                    variant="outlined"
                                    type="upload"
                                    component="span"
                                  >
                                    <i className="fas fa-file mr-1" />{" "}
                                    <span className="text-blue">Select File</span>
                                  </Button>
                                </label>
                              ) : (
                                <>
                                  {selectedFiles && selectedFiles.length > 0
                                    ? selectedFiles[0].name
                                    : null}
                                  <Button
                                    className="btn-sm btn-upload ml-2"
                                    color="primary"
                                    variant="contained"
                                    component="span"
                                    disabled={!selectedFiles}
                                    onClick={this.upload}
                                  >
                                    upload <i className="fas fa-upload ml-1"></i>
                                  </Button>
                                </>
                              )}
                            </fieldset>
                            {/* </div> */}
                            <div className=" col-md-9 m-0">
                              <Typography
                                variant="subtitle2"
                                className={`upload-message ${isError ? "error" : ""
                                  }`}
                              >
                                <span className="text-green">{message}</span>
                              </Typography>
                            </div>
                          </>
                        ) : (
                          <div>
                            Quatation file : &nbsp;{" "}
                            <span as="button" onClick={this.handleQuatation}>
                              {this.state.file}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    {this.state.potype === "1" ? (
                      <>
                        {this.state.serviceList.length === 0 ||
                          (this.state.contracttype === "Milestone" &&
                            this.state.milestone.length === 0) ? (
                          <button
                            className="btn btn-sm hovbuttonColour"
                            disabled
                          >Save
                          </button>
                        ) : (
                          <button
                            className="btn btn-sm hovbuttonColour"
                            type="submit"
                            onClick={this.handleSubmit}
                            disabled={this.state.sloader}
                          >
                            {this.state.sloader === true ? (
                              <>
                                <Spinner
                                  animation="border"
                                  size="sm"
                                  className="mr-1"
                                />
                                {"Saving..."}{" "}
                              </>
                            ) : (
                              <>
                                <i className="fa fa-save mr-1" /> {"Save"}
                              </>
                            )}
                          </button>
                        )}
                      </>
                    ) : (
                      displaysavebutton
                    )}
                    {displayrequest}
                    <span
                      as="button"
                      className="btn btn-sm ml-2 bg-white shadow-sm"
                      // to={{ pathname: "/purchaseorder" }}
                      onClick={() => this.props.navigate(-1)}
                    >
                      <b className="text-danger">X</b> Cancel
                    </span>
                    <fieldset className=" col-md-12">
                      <label className="text-red text-xs">
                        Note : If any selection is wrong or with invalid
                        characters, please cancel the selection with "x" button
                        in selection and reselect the Field.
                      </label>
                    </fieldset>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        {/* /.card-header */}
        {/* form start */}

        <Footer />
      </div>
    );
  }
}
export default withRouter(NewPurchase);
